



<section class="section-first section-md" #target>
   <section class="sub-header">
       <div class="container">
         <div class="row align-items-center">
           <div class="col-lg-9">
             <div class="media align-items-center">
               <div class="media-left">
                 <div class="qualityScoreSection">
                    <svg _ngcontent-sqo-c1="" class="circular-chart red" viewBox="0 0 36 36"><path _ngcontent-sqo-c1="" class="circle-bg" d="M18 2.0845
                       a 15.9155 15.9155 0 0 1 0 31.831
                       a 15.9155 15.9155 0 0 1 0 -31.831"></path><path _ngcontent-sqo-c1="" class="circle" d="M18 2.0845
                       a 15.9155 15.9155 0 0 1 0 31.831
                       a 15.9155 15.9155 0 0 1 0 -31.831" stroke-dasharray="14.634146,100"></path><!----><!----><text _ngcontent-sqo-c1="" class="percentage ng-star-inserted" style="font-size: 10px;font-weight: 600;" x="9" y="22" data-gtm-vis-recent-on-screen13498092_510="1655" data-gtm-vis-first-on-screen13498092_510="1655" data-gtm-vis-total-visible-time13498092_510="100" data-gtm-vis-has-fired13498092_510="1" data-gtm-vis-recent-on-screen13498092_522="1658" data-gtm-vis-first-on-screen13498092_522="1658" data-gtm-vis-total-visible-time13498092_522="100" data-gtm-vis-has-fired13498092_522="1">15%</text><!----></svg>
                 </div>
               </div>
               <div class="media-body">
                 <div class="section-title">
                   <h1>Citation Checker Report</h1>
                   <p>Sample Citation Check Report | Generated on: Feb 4, 2025, 6:38:09 PM</p>
                 </div>
               </div>
             </div>
           </div>
           <!-- <div class="col-lg-3">
             <div class="search-box" *ngIf="creditsDetails['user_type']=='PREMIUM'">
               <a (click)="backToReferenceQuality()"[routerLink]="['/citation-check-tool']">Back to reports</a>
             </div>
           </div> -->
         </div>
       </div>
     </section>
   <div class="container">
     <div class="row">
       <div class="col-lg-4">
         <ul class="nav nav-pills reference-tabs" (click)="scroll(target)">
           <li class="nav-item">
             <a class="nav-link big active" data-toggle="pill" href="#Overview">Overview</a>
           </li>
           <li class="nav-item" >
             <a class="nav-link big" data-toggle="pill" href="#CitationsNeedAttention">Citations need Review</a>
           </li>
           <li class="nav-item" >
             <a class="nav-link" data-toggle="pill" href="#RetractedReferences">Retracted
               <span>4</span></a>
           </li>
           <li class="nav-item">
             <a class="nav-link" data-toggle="pill" href="#OldReferences">Published Long Ago
               <span>30</span></a>
           </li>
           <li class="nav-item">
             <a class="nav-link" data-toggle="pill" href="#Unverified">Unverified
               <span>1</span></a>
           </li>
           <li class="nav-item">
             <a class="nav-link" data-toggle="pill" href="#JournalOveruse">Journal Bias
               <span>13</span></a>
           </li>
           <li class="nav-item">
             <a class="nav-link big" data-toggle="pill" href="#goodCitations">Good-to-use Citations</a>
           </li>
         </ul>
       </div>

       <div class="col-lg-8">
           <div class="tab-content">
               <!-- Overview-->
               <div class="tab-pane active" id="Overview">
                 <div class="panel-card">
                   <h3>Citation Analysis Overview</h3>
                   <div class="row">
                     <div class="col-12 text-center">
                       <div class="graph-box">
                         <img src="../../../../../assets/images/overview-graph.jpg" class="img-fluid" alt="graph" />
                       </div>
                     </div>
                   </div>

                   <div class="row match-box justify-content-center">
                     <div class="col-sm-12 col-md-12 col-lg-6 col-12 dflex">
                       <div class="overview-card c-card high-border">
                         <div class="media">
                           <div class="media-left">
                             <div class="overview-right">
                               <h6 class="tx-high">4</h6>
                               <h5>High <br/>Risk</h5>
                             </div>
                           </div>
                           <div class="media-body high-border">
                             <div class="row">
                               <div class="col-12">
                                 <div class="overview-count">
                                   <h3>4</h3>
                                   <span>Retracted </span>
                                 </div>
                               </div>
                             </div>
                             <p>These citations highly likely weaken the strength of argumentation and must be replaced with credible alternatives.</p>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="col-sm-12 col-md-12 col-lg-6 col-12 dflex">
                       <div class="overview-card c-card medium-border">
                         <div class="media">
                           <div class="media-left">
                             <div class="overview-right">
                               <h6 class="tx-medium">31</h6>
                               <h5>Medium <br/> Risk</h5>
                             </div>
                           </div>
                           <div class="media-body medium-border">
                             <div class="row">
                               <div class="col-6">
                                 <div class="overview-count">
                                   <h3>30</h3>
                                   <span>Published Long Ago </span>
                                 </div>
                               </div>
                               <div class="col-6">
                                 <div class="overview-count">
                                   <h3>1</h3>
                                   <span>Unverified</span>
                                 </div>
                               </div>
                             </div>
                             <p>These citations may weaken your argumentation. We highly recommend replacing with better alternatives.</p>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                   <div class="row match-box justify-content-center">
                     <div class="col-sm-12 col-md-12 col-lg-6 col-12 dflex">
                       <div class="overview-card c-card low-border">
                         <div class="media">
                           <div class="media-left">
                             <div class="overview-right">
                               <h6 class="tx-low">13</h6>
                               <h5>Low <br/>Risk</h5>
                             </div>
                           </div>
                           <div class="media-body low-border">
                             <div class="row">
                               <div class="col-12">
                                 <div class="overview-count">
                                   <h3>13</h3>
                                   <span>Journal Bias </span>
                                 </div>
                               </div>
                             </div>
                             <p>These citations may not adequately support your argumentation. Do review and replace with better alternative where possible.</p>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="col-sm-12 col-md-12 col-lg-6 col-12 dflex">
                       <div class="overview-card c-card success-border">
                         <div class="media">
                           <div class="media-left">
                             <div class="overview-right">
                               <h6 class="tx-success">6</h6>
                               <h5>No <br/>Risk</h5>
                             </div>
                           </div>
                           <div class="media-body success-border">
                             <div class="row">
                               <div class="col-12">
                                 <div class="overview-count">
                                   <h3>6</h3>
                                   <span>Good to use </span>
                                 </div>
                               </div>
                             </div>
                             <p>Our Al could not find any issues for these citations. You may review to ensure that these are credible for your research context.</p>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>

               <!-- CitationsNeedAttention -->
               <div class="tab-pane" id="CitationsNeedAttention">
                   <div class="panel-card">
                       <h3>35 out of 41 total citations need attention</h3>

                       <div class="rf-accordion" id="accordion">
                          <!---->
                          <div
                             
                              class="card ng-star-inserted"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne0">
                                      <ul class="icon-list">
                                          <li>
                                              Sarkar, A., Shukla, S. K., Alqatawni, A., Kumar, A., Addya, S., Tsygankov, A. Y., and Rafiq, K. The Role of Allograft Inflammatory Factor-1 in the Effects of Experimental Diabetes on B Cell Functions in the Heart.
                                              Front. Cardiovasc. Med. 5:126.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul
                                     
                                      class="ng-star-inserted"
                                      data-gtm-vis-first-on-screen13498092_510="343715"
                                      data-gtm-vis-total-visible-time13498092_510="100"
                                      data-gtm-vis-has-fired13498092_510="1"
                                      data-gtm-vis-first-on-screen13498092_522="343815"
                                      data-gtm-vis-total-visible-time13498092_522="100"
                                      data-gtm-vis-has-fired13498092_522="1"
                                  >
                                      <!---->
                                      <li
                                         
                                          class="badge high-risk ng-star-inserted"
                                          data-gtm-vis-first-on-screen13498092_510="343721"
                                          data-gtm-vis-total-visible-time13498092_510="100"
                                          data-gtm-vis-has-fired13498092_510="1"
                                          data-gtm-vis-first-on-screen13498092_522="343817"
                                          data-gtm-vis-total-visible-time13498092_522="100"
                                          data-gtm-vis-has-fired13498092_522="1"
                                      >
                                          Retracted after publication
                                      </li>
                                      <!----><!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne0">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fcvm.2018.00126">
                                                      <span> RETRACTED: The Role of Allograft Inflammatory Factor-1 in the Effects of Experimental Diabetes on B Cell Functions in the Heart</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Cardiovascular Medicine</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Sarkar Amrita et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Amrita Sarkar</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Sanket K. Shukla</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Aseel Alqatawni</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Anil Kumar</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Sankar Addya</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Alexander Y. Tsygankov</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Khadija Rafiq</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2018</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                              data-gtm-vis-first-on-screen13498092_510="343735"
                              data-gtm-vis-total-visible-time13498092_510="100"
                              data-gtm-vis-has-fired13498092_510="1"
                              data-gtm-vis-first-on-screen13498092_522="343819"
                              data-gtm-vis-total-visible-time13498092_522="100"
                              data-gtm-vis-has-fired13498092_522="1"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne1">
                                      <ul class="icon-list">
                                          <li>
                                              Wakefield AJ, Murch SH, Anthony A, Linnell J, Casson DM, Malik M, Berelowitz M, Dhillon AP, Thomson MA, Harvey P, Valentine A, Davies SE, Walker-Smith JA. Ileal-lymphoid-nodular hyperplasia, non-specific colitis, and
                                              pervasive developmental disorder in children. LANCET; FEB 28 1998.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul
                                     
                                      class="ng-star-inserted"
                                      data-gtm-vis-first-on-screen13498092_510="343740"
                                      data-gtm-vis-total-visible-time13498092_510="100"
                                      data-gtm-vis-has-fired13498092_510="1"
                                      data-gtm-vis-first-on-screen13498092_522="343822"
                                      data-gtm-vis-total-visible-time13498092_522="100"
                                      data-gtm-vis-has-fired13498092_522="1"
                                  >
                                      <!---->
                                      <li
                                         
                                          class="badge high-risk ng-star-inserted"
                                          data-gtm-vis-first-on-screen13498092_510="343745"
                                          data-gtm-vis-total-visible-time13498092_510="100"
                                          data-gtm-vis-has-fired13498092_510="1"
                                          data-gtm-vis-first-on-screen13498092_522="343824"
                                          data-gtm-vis-total-visible-time13498092_522="100"
                                          data-gtm-vis-has-fired13498092_522="1"
                                      >
                                          Retracted after publication
                                      </li>
                                      <!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                          data-gtm-vis-first-on-screen13498092_510="343751"
                                          data-gtm-vis-total-visible-time13498092_510="100"
                                          data-gtm-vis-has-fired13498092_510="1"
                                          data-gtm-vis-first-on-screen13498092_522="343826"
                                          data-gtm-vis-total-visible-time13498092_522="100"
                                          data-gtm-vis-has-fired13498092_522="1"
                                      >
                                          Published 27 years ago
                                      </li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne1">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1016/s0140-6736(97)11096-0">
                                                      <span> RETRACTED: Ileal-lymphoid-nodular hyperplasia, non-specific colitis, and pervasive developmental disorder in children</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> The Lancet</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Wakefield AJ et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>AJ Wakefield</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>SH Murch</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>A Anthony</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>J Linnell</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>DM Casson</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>M Malik</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>M Berelowitz</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>AP Dhillon</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>MA Thomson</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>P Harvey</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>A Valentine</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>SE Davies</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>JA Walker-Smith</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 1998</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                              data-gtm-vis-first-on-screen13498092_510="343760"
                              data-gtm-vis-total-visible-time13498092_510="100"
                              data-gtm-vis-has-fired13498092_510="1"
                              data-gtm-vis-first-on-screen13498092_522="343828"
                              data-gtm-vis-total-visible-time13498092_522="100"
                              data-gtm-vis-has-fired13498092_522="1"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne2">
                                      <ul class="icon-list">
                                          <li>
                                              Voinnet O, Rivas S, Mestre P, Baulcombe D. An enhanced transient expression system in plants based on suppression of gene silencing by the p19 protein of tomato bushy stunt virus. PLANT J; MAR 2003.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul
                                     
                                      class="ng-star-inserted"
                                  >
                                      <!---->
                                      <li
                                         
                                          class="badge high-risk ng-star-inserted"
                                      >
                                          Retracted after publication
                                      </li>
                                      <!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                      >
                                          Published 22 years ago
                                      </li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne2">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1046/j.1365-313x.2003.01676.x">
                                                      <span> Retracted: An enhanced transient expression system in plants based on suppression of gene silencing by the p19 protein of tomato bushy stunt virus</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> The Plant Journal</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Voinnet Olivier et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Olivier Voinnet</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Susana Rivas</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Pere Mestre</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>David Baulcombe</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2003</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                              data-gtm-vis-first-on-screen13498092_510="343792"
                              data-gtm-vis-total-visible-time13498092_510="100"
                              data-gtm-vis-has-fired13498092_510="1"
                              data-gtm-vis-first-on-screen13498092_522="343839"
                              data-gtm-vis-total-visible-time13498092_522="100"
                              data-gtm-vis-has-fired13498092_522="1"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne3">
                                      <ul class="icon-list">
                                          <li>Gouaux E, MacKinnon R. Principles of selective ion transport in channels and pumps. science 2005; 310:1461-5.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul
                                     
                                      class="ng-star-inserted"
                                      data-gtm-vis-first-on-screen13498092_510="343796"
                                      data-gtm-vis-total-visible-time13498092_510="100"
                                      data-gtm-vis-has-fired13498092_510="1"
                                      data-gtm-vis-first-on-screen13498092_522="343842"
                                      data-gtm-vis-total-visible-time13498092_522="100"
                                      data-gtm-vis-has-fired13498092_522="1"
                                  >
                                      <!----><!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                          data-gtm-vis-first-on-screen13498092_510="343798"
                                          data-gtm-vis-total-visible-time13498092_510="100"
                                          data-gtm-vis-has-fired13498092_510="1"
                                          data-gtm-vis-first-on-screen13498092_522="343844"
                                          data-gtm-vis-total-visible-time13498092_522="100"
                                          data-gtm-vis-has-fired13498092_522="1"
                                      >
                                          Published 20 years ago
                                      </li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne3">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1126/science.1113666"><span> Principles of Selective Ion Transport in Channels and Pumps</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Science</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Gouaux Eric et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Eric Gouaux</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Roderick MacKinnon</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2005</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                              data-gtm-vis-first-on-screen13498092_510="343801"
                              data-gtm-vis-total-visible-time13498092_510="100"
                              data-gtm-vis-has-fired13498092_510="1"
                              data-gtm-vis-first-on-screen13498092_522="343846"
                              data-gtm-vis-total-visible-time13498092_522="100"
                              data-gtm-vis-has-fired13498092_522="1"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne4">
                                      <ul class="icon-list">
                                          <li>Hodgkin AL, Huxley AF. Action potentials recorded from inside a nerve fibre. Nature 1939; 144:710-1.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul
                                     
                                      class="ng-star-inserted"
                                      data-gtm-vis-first-on-screen13498092_510="343803"
                                      data-gtm-vis-total-visible-time13498092_510="100"
                                      data-gtm-vis-has-fired13498092_510="1"
                                      data-gtm-vis-first-on-screen13498092_522="343848"
                                      data-gtm-vis-total-visible-time13498092_522="100"
                                      data-gtm-vis-has-fired13498092_522="1"
                                  >
                                      <!----><!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                          data-gtm-vis-first-on-screen13498092_510="343805"
                                          data-gtm-vis-total-visible-time13498092_510="100"
                                          data-gtm-vis-has-fired13498092_510="1"
                                          data-gtm-vis-first-on-screen13498092_522="343850"
                                          data-gtm-vis-total-visible-time13498092_522="100"
                                          data-gtm-vis-has-fired13498092_522="1"
                                      >
                                          Published 86 years ago
                                      </li>
                                      <!---->
                                      <li
                                         
                                          class="badge low-risk ng-star-inserted"
                                          data-gtm-vis-first-on-screen13498092_510="343809"
                                          data-gtm-vis-total-visible-time13498092_510="100"
                                          data-gtm-vis-has-fired13498092_510="1"
                                          data-gtm-vis-first-on-screen13498092_522="343854"
                                          data-gtm-vis-total-visible-time13498092_522="100"
                                          data-gtm-vis-has-fired13498092_522="1"
                                      >
                                          Publishing journal used too many times
                                      </li>
                                      <!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne4">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b><a target="_blank" href="https://dx.doi.org/10.1038/144710a0"><span> Action Potentials Recorded from Inside a Nerve Fibre</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      HODGKIN A. L. et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>A. L. HODGKIN</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>A. F. HUXLEY</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 1939</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                              data-gtm-vis-first-on-screen13498092_510="343811"
                              data-gtm-vis-total-visible-time13498092_510="100"
                              data-gtm-vis-has-fired13498092_510="1"
                              data-gtm-vis-first-on-screen13498092_522="358728"
                              data-gtm-vis-total-visible-time13498092_522="100"
                              data-gtm-vis-has-fired13498092_522="1"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne5">
                                      <ul class="icon-list">
                                          <li>
                                              Becchetti A, Arcangeli A. Integrins and ion channels in cell migration: implications for neuronal development, wound healing and metastatic spread. Integrins and Ion Channels: Springer, 2010:107-23.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul
                                     
                                      class="ng-star-inserted"
                                      data-gtm-vis-first-on-screen13498092_510="358751"
                                      data-gtm-vis-total-visible-time13498092_510="100"
                                      data-gtm-vis-has-fired13498092_510="1"
                                      data-gtm-vis-first-on-screen13498092_522="358764"
                                      data-gtm-vis-total-visible-time13498092_522="100"
                                      data-gtm-vis-has-fired13498092_522="1"
                                  >
                                      <!----><!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                          data-gtm-vis-first-on-screen13498092_510="358756"
                                          data-gtm-vis-total-visible-time13498092_510="100"
                                          data-gtm-vis-has-fired13498092_510="1"
                                          data-gtm-vis-first-on-screen13498092_522="358768"
                                          data-gtm-vis-total-visible-time13498092_522="100"
                                          data-gtm-vis-has-fired13498092_522="1"
                                      >
                                          Published 15 years ago
                                      </li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne5">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1007/978-1-4419-6066-5_10">
                                                      <span> Integrins and Ion Channels in Cell Migration: Implications for Neuronal Development, Wound Healing and Metastatic Spread</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Advances in Experimental Medicine and Biology</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Becchetti Andrea et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Andrea Becchetti</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Annarosa Arcangeli</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2010</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                              data-gtm-vis-first-on-screen13498092_510="358771"
                              data-gtm-vis-total-visible-time13498092_510="100"
                              data-gtm-vis-has-fired13498092_510="1"
                              data-gtm-vis-first-on-screen13498092_522="358775"
                              data-gtm-vis-total-visible-time13498092_522="100"
                              data-gtm-vis-has-fired13498092_522="1"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne6">
                                      <ul class="icon-list">
                                          <li>Lawson S. Phenotype and function of somatic primary afferent nociceptive neurones with C-, Aδ-or Aα/β-fibres. Experimental physiology 2002; 87:239-44.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul
                                     
                                      class="ng-star-inserted"
                                      data-gtm-vis-first-on-screen13498092_510="358785"
                                      data-gtm-vis-total-visible-time13498092_510="100"
                                      data-gtm-vis-has-fired13498092_510="1"
                                      data-gtm-vis-first-on-screen13498092_522="358800"
                                      data-gtm-vis-total-visible-time13498092_522="100"
                                      data-gtm-vis-has-fired13498092_522="1"
                                  >
                                      <!----><!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                          data-gtm-vis-first-on-screen13498092_510="358790"
                                          data-gtm-vis-total-visible-time13498092_510="100"
                                          data-gtm-vis-has-fired13498092_510="1"
                                          data-gtm-vis-first-on-screen13498092_522="358803"
                                          data-gtm-vis-total-visible-time13498092_522="100"
                                          data-gtm-vis-has-fired13498092_522="1"
                                      >
                                          Published 23 years ago
                                      </li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne6">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1113/eph8702350">
                                                      <span> Phenotype and Function of Somatic Primary Afferent Nociceptive Neurones with C‐, Aδ‐ or Aα/β‐Fibres</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Experimental Physiology</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Lawson S. N.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>S. N. Lawson</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2002</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                              data-gtm-vis-first-on-screen13498092_510="358797"
                              data-gtm-vis-total-visible-time13498092_510="100"
                              data-gtm-vis-has-fired13498092_510="1"
                              data-gtm-vis-first-on-screen13498092_522="358819"
                              data-gtm-vis-total-visible-time13498092_522="100"
                              data-gtm-vis-has-fired13498092_522="1"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne7">
                                      <ul class="icon-list">
                                          <li>Park J, Luo ZD. Calcium channel functions in pain processing. Channels 2010; 4:510-7.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul
                                     
                                      class="ng-star-inserted"
                                      data-gtm-vis-first-on-screen13498092_510="358806"
                                      data-gtm-vis-total-visible-time13498092_510="100"
                                      data-gtm-vis-has-fired13498092_510="1"
                                      data-gtm-vis-first-on-screen13498092_522="358823"
                                      data-gtm-vis-total-visible-time13498092_522="100"
                                      data-gtm-vis-has-fired13498092_522="1"
                                  >
                                      <!----><!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                          data-gtm-vis-first-on-screen13498092_510="358813"
                                          data-gtm-vis-total-visible-time13498092_510="100"
                                          data-gtm-vis-has-fired13498092_510="1"
                                          data-gtm-vis-first-on-screen13498092_522="358828"
                                          data-gtm-vis-total-visible-time13498092_522="100"
                                          data-gtm-vis-has-fired13498092_522="1"
                                      >
                                          Published 15 years ago
                                      </li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne7">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b><a target="_blank" href="https://dx.doi.org/10.4161/chan.4.6.12869"><span> Calcium channel functions in pain processing</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Channels</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Park John et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>John Park</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Z. David Luo</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2010</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                              data-gtm-vis-first-on-screen13498092_510="358816"
                              data-gtm-vis-total-visible-time13498092_510="100"
                              data-gtm-vis-has-fired13498092_510="1"
                              data-gtm-vis-first-on-screen13498092_522="358849"
                              data-gtm-vis-total-visible-time13498092_522="100"
                              data-gtm-vis-has-fired13498092_522="1"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne8">
                                      <ul class="icon-list">
                                          <li>Guharay F, Sachs F. Stretch‐activated single ion channel currents in tissue‐cultured embryonic chick skeletal muscle. The Journal of physiology 1984; 352:685-701.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul
                                     
                                      class="ng-star-inserted"
                                      data-gtm-vis-first-on-screen13498092_510="358839"
                                      data-gtm-vis-total-visible-time13498092_510="100"
                                      data-gtm-vis-has-fired13498092_510="1"
                                      data-gtm-vis-first-on-screen13498092_522="358851"
                                      data-gtm-vis-total-visible-time13498092_522="100"
                                      data-gtm-vis-has-fired13498092_522="1"
                                  >
                                      <!----><!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                          data-gtm-vis-first-on-screen13498092_510="358844"
                                          data-gtm-vis-total-visible-time13498092_510="100"
                                          data-gtm-vis-has-fired13498092_510="1"
                                          data-gtm-vis-first-on-screen13498092_522="358855"
                                          data-gtm-vis-total-visible-time13498092_522="100"
                                          data-gtm-vis-has-fired13498092_522="1"
                                      >
                                          Published 41 years ago
                                      </li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne8">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1113/jphysiol.1984.sp015317">
                                                      <span> Stretch‐activated single ion channel currents in tissue‐cultured embryonic chick skeletal muscle.</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> The Journal of Physiology</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Guharay F et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>F Guharay</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>F Sachs</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 1984</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted" data-gtm-vis-first-on-screen13498092_510="358862" data-gtm-vis-total-visible-time13498092_510="100" data-gtm-vis-has-fired13498092_510="1">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne9">
                                      <ul class="icon-list">
                                          <li>Paoletti P, Ascher P. Mechanosensitivity of NMDA receptors in cultured mouse central neurons. Neuron 1994; 13:645-55.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 31 years ago</li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne9">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1016/0896-6273(94)90032-9"><span> Mechanosensitivity of NMDA receptors in cultured mouse central neurons</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Neuron</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Paoletti Pierre et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Pierre Paoletti</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Philippe Ascher</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 1994</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne10">
                                      <ul class="icon-list">
                                          <li>Morris CE. Voltage-gated channel mechanosensitivity: fact or friction? Frontiers in physiology 2011; 2:25.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 14 years ago</li>
                                      <!---->
                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne10">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2011.00025"><span> Voltage-Gated Channel Mechanosensitivity: Fact or Friction?</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Morris Catherine E.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Catherine E. Morris</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2011</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne11">
                                      <ul class="icon-list">
                                          <li>Haswell ES, Phillips R, Rees DC. Mechanosensitive channels: what can they do and how do they do it? Structure (London, England : 1993) 2011; 19:1356-69.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 14 years ago</li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne11">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1016/j.str.2011.09.005"><span> Mechanosensitive Channels: What Can They Do and How Do They Do It?</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Structure</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Haswell Elizabeth&nbsp;S. et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Elizabeth&nbsp;S. Haswell</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Rob Phillips</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Douglas&nbsp;C. Rees</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2011</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne12">
                                      <ul class="icon-list">
                                          <li>Maroto R, Raso A, Wood TG, Kurosky A, Martinac B, Hamill OP. TRPC1 forms the stretch-activated cation channel in vertebrate cells. Nature cell biology 2005; 7:179.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 20 years ago</li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne12">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1038/ncb1218"><span> TRPC1 forms the stretch-activated cation channel in vertebrate cells</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Nature Cell Biology</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Maroto Rosario et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Rosario Maroto</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Albert Raso</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Thomas G. Wood</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Alex Kurosky</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Boris Martinac</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Owen P. Hamill</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2005</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne13">
                                      <ul class="icon-list">
                                          <li>Yuen K. Ip, and Shit F. Chew. Ammonia production, excretion, toxicity, and defense in fish: a review. Frontiers in Physiology 2010.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 15 years ago</li>
                                      <!---->
                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne13">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2010.00134"><span> Ammonia production, excretion, toxicity, and defense in fish: a review</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Ip Yuen
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Yuen Ip</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2010</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne14">
                                      <ul class="icon-list">
                                          <li>
                                              Raj L, Ide T, Gurkar AU, Foley M, Schenone M, Li X, Tolliday NJ, Golub TR, Carr SA, Shamji AF, Stern AM, Mandinova A, Schreiber SL, Lee SW. Selective killing of cancer cells by a small molecule targeting the stress
                                              response to ROS. NATURE: JUL 2011.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 14 years ago</li>
                                      <!---->
                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne14">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1038/nature10167">
                                                      <span> Selective killing of cancer cells by a small molecule targeting the stress response to ROS</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Raj Lakshmi et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Lakshmi Raj</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Takao Ide</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Aditi U. Gurkar</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Michael Foley</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Monica Schenone</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Xiaoyu Li</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Nicola J. Tolliday</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Todd R. Golub</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Steven A. Carr</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Alykhan F. Shamji</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Andrew M. Stern</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Anna Mandinova</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Stuart L. Schreiber</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Sam W. Lee</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2011</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne15">
                                      <ul class="icon-list">
                                          <li>Becchetti A, Munaron L, Arcangeli A. The role of ion channels and transporters in cell proliferation and cancer. Frontiers in physiology 2013; 4:312.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                      <!---->
                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne15">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2013.00312"><span> The role of ion channels and transporters in cell proliferation and cancer</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Becchetti Andrea et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Andrea Becchetti</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Luca Munaron</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Annarosa Arcangeli</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2013</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne16">
                                      <ul class="icon-list">
                                          <li>Jardín I, López JJ, Diez R, Sánchez-Collado J, Cantonero C, Albarrán L, et al. TRPs in pain sensation. Frontiers in physiology 2017; 8:392.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!----><!---->
                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne16">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b><a target="_blank" href="https://dx.doi.org/10.3389/fphys.2017.00392"><span> TRPs in Pain Sensation</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Jardín Isaac et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Isaac Jardín</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>José J. López</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Raquel Diez</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>José Sánchez-Collado</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Carlos Cantonero</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Letizia Albarrán</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Geoffrey E. Woodard</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Pedro C. Redondo</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Ginés M. Salido</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Tarik Smani</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Juan A. Rosado</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2017</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne17">
                                      <ul class="icon-list">
                                          <li>Heimo Mairbäurl. Red blood cells in sports: effects of exercise and training on oxygen supply by red blood cells. Frontiers in Physiology 2013.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                      <!---->
                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne17">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2013.00332">
                                                      <span> Red blood cells in sports: effects of exercise and training on oxygen supply by red blood cells</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Mairbäurl Heimo
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Heimo Mairbäurl</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2013</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne18">
                                      <ul class="icon-list">
                                          <li>Djuna Z. de Back, Elena B. Kostova, Marian van Kraaij, Timo K. van den Berg and Robin van Bruggen. Of macrophages and red blood cells; a complex love story. Frontiers in Physiology 2014.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                      <!---->
                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne18">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2014.00009"><span> Of macrophages and red blood cells; a complex love story</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      de Back Djuna Z. et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Djuna Z. de Back</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Elena B. Kostova</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Marian van Kraaij</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Timo K. van den Berg</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Robin van Bruggen</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2014</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne19">
                                      <ul class="icon-list">
                                          <li>SeongHun Yoon, Mario Zuccarello and Robert M. Rapoport. pCO2 and pH regulation of cerebral blood flow. Frontiers in Physiology 2010.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 13 years ago</li>
                                      <!---->
                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne19">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b><a target="_blank" href="https://dx.doi.org/10.3389/fphys.2012.00365"><span> pCO2 and pH regulation of cerebral blood flow</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Yoon SeongHun et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>SeongHun Yoon</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Mario Zuccarello</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Robert M. Rapoport</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2012</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne20">
                                      <ul class="icon-list">
                                          <li>
                                              Sun, Q., Li, T., Li, Y., Wei, L., Zhang, M., and Deng, S. Bactericidal/Permeability-Increasing Protein Improves Cognitive Impairment in Diabetic Mice via Blockade of the LPS-LBP-TLR4 Signaling Pathway. Front.
                                              Physiol. 2021 11:718.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!---->
                                      <li class="badge high-risk ng-star-inserted">Retracted after publication</li>
                                      <!----><!---->
                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne20">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2020.00718">
                                                      <span> RETRACTED: Bactericidal/Permeability-Increasing Protein Improves Cognitive Impairment in Diabetic Mice via Blockade of the LPS-LBP-TLR4 Signaling Pathway</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Sun Qin et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Qin Sun</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Tingxin Li</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Yamei Li</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Lingling Wei</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Min Zhang</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Shaoping Deng</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2021</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne21">
                                      <ul class="icon-list">
                                          <li>Del Rio A, Perez-Jimenez R, Liu R, Roca-Cusachs P, Fernandez JM, Sheetz MP. Stretching single talin rod molecules activates vinculin binding. Science 2009; 323:638-41.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 16 years ago</li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne21">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1126/science.1162912"><span> Stretching Single Talin Rod Molecules Activates Vinculin Binding</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Science</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      del Rio Armando et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Armando del Rio</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Raul Perez-Jimenez</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Ruchuan Liu</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Pere Roca-Cusachs</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Julio M. Fernandez</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Michael P. Sheetz</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2009</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne22">
                                      <ul class="icon-list">
                                          <li>Zhao Q, Zhou H, Chi S, Wang Y, Wang J, Geng J, et al. Structure and mechanogating mechanism of the Piezo1 channel. Nature 2018; 554:487.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!----><!---->
                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne22">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1038/nature25743"><span> Structure and mechanogating mechanism of the Piezo1 channel</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Zhao Qiancheng et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Qiancheng Zhao</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Heng Zhou</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Shaopeng Chi</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Yanfeng Wang</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Jianhua Wang</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Jie Geng</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Kun Wu</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Wenhao Liu</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Tingxin Zhang</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Meng-Qiu Dong</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Jiawei Wang</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Xueming Li</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Bailong Xiao</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2018</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne23">
                                      <ul class="icon-list">
                                          <li>Goodman MB, Ernstrom GG, Chelur DS, O'Hagan R, Yao CA, Chalfie M. MEC-2 regulates C. elegans DEG/ENaC channels needed for mechanosensation. Nature 2002; 415:1039-42.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 23 years ago</li>
                                      <!---->
                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne23">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1038/4151039a"><span> MEC-2 regulates C. elegans DEG/ENaC channels needed for mechanosensation</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Goodman Miriam B. et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Miriam B. Goodman</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Glen G. Ernstrom</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Dattananda S. Chelur</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Robert O'Hagan</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>C. Andrea Yao</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Martin Chalfie</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2002</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne24">
                                      <ul class="icon-list">
                                          <li>Wang W, Black SS, Edwards MD, Miller S, Morrison EL, Bartlett W, et al. The structure of an open form of an E. coli mechanosensitive channel at 3.45 Å resolution. Science 2008; 321:1179-83.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 17 years ago</li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne24">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1126/science.1159262">
                                                      <span> The Structure of an Open Form of an&lt;i&gt;E. coli&lt;/i&gt;Mechanosensitive Channel at 3.45 Å Resolution</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Science</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Wang Wenjian et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Wenjian Wang</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Susan S. Black</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Michelle D. Edwards</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Samantha Miller</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Emma L. Morrison</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Wendy Bartlett</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Changjiang Dong</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>James H. Naismith</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Ian R. Booth</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2008</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne25">
                                      <ul class="icon-list">
                                          <li>Brohawn SG, del Mármol J, MacKinnon R. Crystal structure of the human K2P TRAAK, a lipid-and mechano-sensitive K+ ion channel. Science 2012; 335:436-41.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 13 years ago</li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne25">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1126/science.1213808">
                                                      <span> Crystal Structure of the Human K2P TRAAK, a Lipid- and Mechano-Sensitive K &lt;sup&gt;+&lt;/sup&gt; Ion Channel</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Science</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Brohawn Stephen G. et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Stephen G. Brohawn</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Josefina del Mármol</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Roderick MacKinnon</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2012</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne26">
                                      <ul class="icon-list">
                                          <li>Wemmie JA, Taugher RJ, Kreple CJ. Acid-sensing ion channels in pain and disease. Nature Reviews Neuroscience 2013; 14:461-71.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne26">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b><a target="_blank" href="https://dx.doi.org/10.1038/nrn3529"><span> Acid-sensing ion channels in pain and disease</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Nature Reviews Neuroscience</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Wemmie John A. et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>John A. Wemmie</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Rebecca J. Taugher</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Collin J. Kreple</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2013</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne27">
                                      <ul class="icon-list">
                                          <li>Tsantoulas C, McMahon SB. Opening paths to novel analgesics: the role of potassium channels in chronic pain. Trends in neurosciences 2014; 37:146-58.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne27">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1016/j.tins.2013.12.002">
                                                      <span> Opening paths to novel analgesics: the role of potassium channels in chronic pain</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Trends in Neurosciences</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Tsantoulas Christoforos et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Christoforos Tsantoulas</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Stephen B. McMahon</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2014</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne28">
                                      <ul class="icon-list">
                                          <li>Delmas P, Coste B. Mechano-gated ion channels in sensory systems. Cell 2013; 155:278-84.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne28">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b><a target="_blank" href="https://dx.doi.org/10.1016/j.cell.2013.09.026"><span> Mechano-Gated Ion Channels in Sensory Systems</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Cell</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Delmas Patrick et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Patrick Delmas</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Bertrand Coste</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2013</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne29">
                                      <ul class="icon-list">
                                          <li>Moreau A, Gosselin-Badaroudine P, Chahine M. Biophysics, pathophysiology, and pharmacology of ion channel gating pores. Frontiers in pharmacology 2014; 5:53.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne29">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphar.2014.00053"><span> Biophysics, pathophysiology, and pharmacology of ion channel gating pores</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Pharmacology</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Moreau Adrien et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Adrien Moreau</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Pascal Gosselin-Badaroudine</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Mohamed Chahine</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2014</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne30">
                                      <ul class="icon-list">
                                          <li>Brohawn SG, Campbell EB, MacKinnon R. Physical mechanism for gating and mechanosensitivity of the human TRAAK K+ channel. Nature 2014; 516:126.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                      <!---->
                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne30">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1038/nature14013"><span> Physical mechanism for gating and mechanosensitivity of the human TRAAK K+ channel</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Brohawn Stephen G. et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Stephen G. Brohawn</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Ernest B. Campbell</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Roderick MacKinnon</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2014</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne31">
                                      <ul class="icon-list">
                                          <li>Peyronnet R, Tran D, Girault T, Frachisse J-M. Mechanosensitive channels: feeling tension in a world under pressure. Frontiers in plant science 2014; 5:558.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne31">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fpls.2014.00558"><span> Mechanosensitive channels: feeling tension in a world under pressure</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Plant Science</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Peyronnet RÃ©mi et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>RÃ©mi Peyronnet</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Daniel Tran</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Tiffanie Girault</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Jean-Marie Frachisse</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2014</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne32">
                                      <ul class="icon-list">
                                          <li>
                                              Schmidt D, del Mármol J, MacKinnon R. Mechanistic basis for low threshold mechanosensitivity in voltage-dependent K+ channels. Proceedings of the National Academy of Sciences 2012; 109:10352-7.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 13 years ago</li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne32">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1073/pnas.1204700109">
                                                      <span> Mechanistic basis for low threshold mechanosensitivity in voltage-dependent K &lt;sup&gt;+&lt;/sup&gt; channels</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Proceedings of the National Academy of Sciences</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Schmidt Daniel et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Daniel Schmidt</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Josefina del Mármol</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Roderick MacKinnon</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2012</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne33">
                                      <ul class="icon-list">
                                          <li>Sukharev S, Sachs F. Molecular force transduction by ion channels–diversity and unifying principles. J Cell Sci 2012; 125:3075-83.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 13 years ago</li>
                                      <!----><!----><!---->
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne33">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1242/jcs.092353"><span> Molecular force transduction by ion channels – diversity and unifying principles</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Journal of Cell Science</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Sukharev Sergei et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Sergei Sukharev</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Frederick Sachs</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2012</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseOne34">
                                      <ul class="icon-list">
                                          <li>Doe, J. (February 2024). AI is changing the workplace faster than expected. The New York Times. https://www.nytimes.com/example-article</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <!---->
                                  <ul class="ng-star-inserted">
                                      <!----><!----><!----><!----><!---->
                                      <li class="badge medium-risk ng-star-inserted" style="display: inline-block;">Unverified</li>
                                  </ul>
                                  <!---->
                              </div>
                              <!---->
                              <div class="collapse ng-star-inserted" id="collapseOne34">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1016/s0262-4079(24)01047-9"><span> Cleaner ship emissions may warm the planet far faster than expected</span></a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> New Scientist</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Dinneen James
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>James Dinneen</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2024</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      
                   </div>
               </div>

               <!-- RetractedReferences -->
               <div class="tab-pane" id="RetractedReferences">
                   <div class="panel-card">
                       <h3>Retracted: 4 citations out of 41  <span class="badge high-risk">High Risk</span></h3>
                       <div class="warning mt-4 mb-4">
                           <div class="media">
                             <div class="media-left">
                               <img src="../../../../../assets/images/Icon_Info.svg" alt="info">
                             </div>
                             <div class="media-body">
                               <p>A retracted citation is one that was published by a journal but is later recalled for research quality, integrity, or other ethical reasons. You should never cite a retracted paper as that seriously impacts the credibility of your argumentation.</p>
                             </div>
                           </div>
                       </div>

                       <div class="danger-outline mb-4 ">
                           Action Required: You will have to remove or replace these citations with more credible articles
                       </div>

                       <div class="rf-accordion" id="accordion">
                          <!---->
                          <div
                             
                              class="card ng-star-inserted"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseFour0">
                                      <ul class="icon-list">
                                          <li>
                                              Sarkar, A., Shukla, S. K., Alqatawni, A., Kumar, A., Addya, S., Tsygankov, A. Y., and Rafiq, K. The Role of Allograft Inflammatory Factor-1 in the Effects of Experimental Diabetes on B Cell Functions in the Heart.
                                              Front. Cardiovasc. Med. 5:126.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li
                                         
                                          class="badge high-risk ng-star-inserted"
                                      >
                                          Retracted after publication
                                      </li>
                                      <!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseFour0">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fcvm.2018.00126">
                                                      <span> RETRACTED: The Role of Allograft Inflammatory Factor-1 in the Effects of Experimental Diabetes on B Cell Functions in the Heart</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Cardiovascular Medicine</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Sarkar Amrita et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Amrita Sarkar</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Sanket K. Shukla</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Aseel Alqatawni</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Anil Kumar</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Sankar Addya</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Alexander Y. Tsygankov</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Khadija Rafiq</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2018</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseFour1">
                                      <ul class="icon-list">
                                          <li>
                                              Wakefield AJ, Murch SH, Anthony A, Linnell J, Casson DM, Malik M, Berelowitz M, Dhillon AP, Thomson MA, Harvey P, Valentine A, Davies SE, Walker-Smith JA. Ileal-lymphoid-nodular hyperplasia, non-specific colitis, and
                                              pervasive developmental disorder in children. LANCET; FEB 28 1998.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li
                                         
                                          class="badge high-risk ng-star-inserted"
                                      >
                                          Retracted after publication
                                      </li>
                                      <!---->
                                      <li
                                         
                                          class="badge medium-risk hide-li ng-star-inserted"
                                      >
                                          Published 27 years ago
                                      </li>
                                      <!----><!----><!----><!----><!---->
                                      <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseFour1">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1016/s0140-6736(97)11096-0">
                                                      <span> RETRACTED: Ileal-lymphoid-nodular hyperplasia, non-specific colitis, and pervasive developmental disorder in children</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> The Lancet</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Wakefield AJ et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>AJ Wakefield</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>SH Murch</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>A Anthony</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>J Linnell</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>DM Casson</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>M Malik</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>M Berelowitz</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>AP Dhillon</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>MA Thomson</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>P Harvey</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>A Valentine</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>SE Davies</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>JA Walker-Smith</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 1998</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseFour2">
                                      <ul class="icon-list">
                                          <li>
                                              Voinnet O, Rivas S, Mestre P, Baulcombe D. An enhanced transient expression system in plants based on suppression of gene silencing by the p19 protein of tomato bushy stunt virus. PLANT J; MAR 2003.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li
                                         
                                          class="badge high-risk ng-star-inserted"
                                      >
                                          Retracted after publication
                                      </li>
                                      <!---->
                                      <li class="badge medium-risk hide-li ng-star-inserted">Published 22 years ago</li>
                                      <!----><!----><!----><!----><!---->
                                      <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseFour2">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1046/j.1365-313x.2003.01676.x">
                                                      <span> Retracted: An enhanced transient expression system in plants based on suppression of gene silencing by the p19 protein of tomato bushy stunt virus</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> The Plant Journal</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Voinnet Olivier et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Olivier Voinnet</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Susana Rivas</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Pere Mestre</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>David Baulcombe</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2003</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                              data-gtm-vis-first-on-screen13498092_510="415739"
                              data-gtm-vis-total-visible-time13498092_510="100"
                              data-gtm-vis-has-fired13498092_510="1"
                              data-gtm-vis-first-on-screen13498092_522="415762"
                              data-gtm-vis-total-visible-time13498092_522="100"
                              data-gtm-vis-has-fired13498092_522="1"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseFour3">
                                      <ul class="icon-list">
                                          <li>
                                              Sun, Q., Li, T., Li, Y., Wei, L., Zhang, M., and Deng, S. Bactericidal/Permeability-Increasing Protein Improves Cognitive Impairment in Diabetic Mice via Blockade of the LPS-LBP-TLR4 Signaling Pathway. Front.
                                              Physiol. 2021 11:718.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li
                                         
                                          class="badge high-risk ng-star-inserted"
                                      >
                                          Retracted after publication
                                      </li>
                                      <!----><!---->
                                      <li class="badge low-risk hide-li ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!----><!----><!---->
                                      <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseFour3">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <p class="pc-para pc-title">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2020.00718">
                                                      <span> RETRACTED: Bactericidal/Permeability-Increasing Protein Improves Cognitive Impairment in Diabetic Mice via Blockade of the LPS-LBP-TLR4 Signaling Pathway</span>
                                                  </a>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Sun Qin et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Qin Sun</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Tingxin Li</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Yamei Li</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Lingling Wei</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Min Zhang</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Shaoping Deng</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <div class="col-12">
                                              <p class="pc-para"><b>Published:</b><span> 2021</span></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      
                   </div>
               </div>

               <!-- Published Long Ago -->
               <div class="tab-pane" id="OldReferences">
                   <div class="panel-card">
                       <h3>Published Long Ago: 30 citations out of 41  <span class="badge medium-risk">Medium Risk</span></h3>
                       <div class="warning mt-4 mb-4">
                           <div class="media">
                             <div class="media-left">
                               <img src="../../../../../assets/images/Icon_Info.svg" alt="info">
                             </div>
                             <div class="media-body">
                               <p>An old citation is one that was published over 10 years before the year of creation of this report. Journals prefer newer citations as they reflect the current status of research on the topic. Note that some old citations may be seminal works and hence would be acceptable (groundbreaking works).</p>
                             </div>
                           </div>
                       </div>

                       <div class="danger-outline mb-4 ">
                           Action Required: Review and replace these citations with newer citations published in peer-reviewed journals.
                       </div>

                       <div class="rf-accordion" id="accordion">
                          <!---->
                          <div
                             
                              class="card ng-star-inserted"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven0">
                                      <ul class="icon-list">
                                          <li>
                                              Wakefield AJ, Murch SH, Anthony A, Linnell J, Casson DM, Malik M, Berelowitz M, Dhillon AP, Thomson MA, Harvey P, Valentine A, Davies SE, Walker-Smith JA. Ileal-lymphoid-nodular hyperplasia, non-specific colitis, and
                                              pervasive developmental disorder in children. LANCET; FEB 28 1998.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                      >
                                          Published 27 years ago
                                      </li>
                                      <!----><!---->
                                      <li class="badge high-risk hide-li ng-star-inserted">Retracted after publication</li>
                                      <!----><!----><!----><!----><!---->
                                      <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven0">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1016/s0140-6736(97)11096-0">
                                                      <span> RETRACTED: Ileal-lymphoid-nodular hyperplasia, non-specific colitis, and pervasive developmental disorder in children</span>
                                                  </a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> The Lancet</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Wakefield AJ et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>AJ Wakefield</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>SH Murch</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>A Anthony</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>J Linnell</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>DM Casson</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>M Malik</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>M Berelowitz</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>AP Dhillon</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>MA Thomson</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>P Harvey</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>A Valentine</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>SE Davies</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>JA Walker-Smith</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 1998</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven1">
                                      <ul class="icon-list">
                                          <li>
                                              Voinnet O, Rivas S, Mestre P, Baulcombe D. An enhanced transient expression system in plants based on suppression of gene silencing by the p19 protein of tomato bushy stunt virus. PLANT J; MAR 2003.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                      >
                                          Published 22 years ago
                                      </li>
                                      <!----><!---->
                                      <li class="badge high-risk hide-li ng-star-inserted">Retracted after publication</li>
                                      <!----><!----><!----><!----><!---->
                                      <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven1">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1046/j.1365-313x.2003.01676.x">
                                                      <span> Retracted: An enhanced transient expression system in plants based on suppression of gene silencing by the p19 protein of tomato bushy stunt virus</span>
                                                  </a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> The Plant Journal</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Voinnet Olivier et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Olivier Voinnet</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Susana Rivas</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Pere Mestre</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>David Baulcombe</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2003</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven2">
                                      <ul class="icon-list">
                                          <li>Gouaux E, MacKinnon R. Principles of selective ion transport in channels and pumps. science 2005; 310:1461-5.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                      >
                                          Published 20 years ago
                                      </li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven2">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1126/science.1113666"><span> Principles of Selective Ion Transport in Channels and Pumps</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Science</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Gouaux Eric et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Eric Gouaux</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Roderick MacKinnon</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2005</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven3">
                                      <ul class="icon-list">
                                          <li>Hodgkin AL, Huxley AF. Action potentials recorded from inside a nerve fibre. Nature 1939; 144:710-1.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                      >
                                          Published 86 years ago
                                      </li>
                                      <!----><!----><!---->
                                      <li class="badge low-risk hide-li ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!----><!----><!---->
                                      <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven3">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b><a target="_blank" href="https://dx.doi.org/10.1038/144710a0"><span> Action Potentials Recorded from Inside a Nerve Fibre</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      HODGKIN A. L. et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>A. L. HODGKIN</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>A. F. HUXLEY</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 1939</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven4">
                                      <ul class="icon-list">
                                          <li>
                                              Becchetti A, Arcangeli A. Integrins and ion channels in cell migration: implications for neuronal development, wound healing and metastatic spread. Integrins and Ion Channels: Springer, 2010:107-23.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                      >
                                          Published 15 years ago
                                      </li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven4">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1007/978-1-4419-6066-5_10">
                                                      <span> Integrins and Ion Channels in Cell Migration: Implications for Neuronal Development, Wound Healing and Metastatic Spread</span>
                                                  </a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Advances in Experimental Medicine and Biology</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Becchetti Andrea et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Andrea Becchetti</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Annarosa Arcangeli</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2010</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven5">
                                      <ul class="icon-list">
                                          <li>Lawson S. Phenotype and function of somatic primary afferent nociceptive neurones with C-, Aδ-or Aα/β-fibres. Experimental physiology 2002; 87:239-44.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                      >
                                          Published 23 years ago
                                      </li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven5">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1113/eph8702350">
                                                      <span> Phenotype and Function of Somatic Primary Afferent Nociceptive Neurones with C‐, Aδ‐ or Aα/β‐Fibres</span>
                                                  </a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Experimental Physiology</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Lawson S. N.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>S. N. Lawson</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2002</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven6">
                                      <ul class="icon-list">
                                          <li>Park J, Luo ZD. Calcium channel functions in pain processing. Channels 2010; 4:510-7.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                      >
                                          Published 15 years ago
                                      </li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven6">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b><a target="_blank" href="https://dx.doi.org/10.4161/chan.4.6.12869"><span> Calcium channel functions in pain processing</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Channels</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Park John et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>John Park</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Z. David Luo</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2010</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card ng-star-inserted"
                          >
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven7">
                                      <ul class="icon-list">
                                          <li>Guharay F, Sachs F. Stretch‐activated single ion channel currents in tissue‐cultured embryonic chick skeletal muscle. The Journal of physiology 1984; 352:685-701.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li
                                         
                                          class="badge medium-risk ng-star-inserted"
                                      >
                                          Published 41 years ago
                                      </li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven7">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1113/jphysiol.1984.sp015317">
                                                      <span> Stretch‐activated single ion channel currents in tissue‐cultured embryonic chick skeletal muscle.</span>
                                                  </a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> The Journal of Physiology</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Guharay F et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>F Guharay</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>F Sachs</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 1984</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted" data-gtm-vis-first-on-screen13498092_510="2154640" data-gtm-vis-total-visible-time13498092_510="100" data-gtm-vis-has-fired13498092_510="1">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven8">
                                      <ul class="icon-list">
                                          <li>Paoletti P, Ascher P. Mechanosensitivity of NMDA receptors in cultured mouse central neurons. Neuron 1994; 13:645-55.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 31 years ago</li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven8">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1016/0896-6273(94)90032-9"><span> Mechanosensitivity of NMDA receptors in cultured mouse central neurons</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Neuron</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Paoletti Pierre et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Pierre Paoletti</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Philippe Ascher</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 1994</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven9">
                                      <ul class="icon-list">
                                          <li>Morris CE. Voltage-gated channel mechanosensitivity: fact or friction? Frontiers in physiology 2011; 2:25.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 14 years ago</li>
                                      <!----><!----><!---->
                                      <li class="badge low-risk hide-li ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!----><!----><!---->
                                      <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven9">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2011.00025"><span> Voltage-Gated Channel Mechanosensitivity: Fact or Friction?</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Morris Catherine E.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Catherine E. Morris</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2011</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven10">
                                      <ul class="icon-list">
                                          <li>Haswell ES, Phillips R, Rees DC. Mechanosensitive channels: what can they do and how do they do it? Structure (London, England : 1993) 2011; 19:1356-69.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 14 years ago</li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven10">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1016/j.str.2011.09.005"><span> Mechanosensitive Channels: What Can They Do and How Do They Do It?</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Structure</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Haswell Elizabeth&nbsp;S. et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Elizabeth&nbsp;S. Haswell</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Rob Phillips</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Douglas&nbsp;C. Rees</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2011</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven11">
                                      <ul class="icon-list">
                                          <li>Maroto R, Raso A, Wood TG, Kurosky A, Martinac B, Hamill OP. TRPC1 forms the stretch-activated cation channel in vertebrate cells. Nature cell biology 2005; 7:179.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 20 years ago</li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven11">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1038/ncb1218"><span> TRPC1 forms the stretch-activated cation channel in vertebrate cells</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Nature Cell Biology</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Maroto Rosario et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Rosario Maroto</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Albert Raso</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Thomas G. Wood</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Alex Kurosky</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Boris Martinac</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Owen P. Hamill</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2005</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven12">
                                      <ul class="icon-list">
                                          <li>Yuen K. Ip, and Shit F. Chew. Ammonia production, excretion, toxicity, and defense in fish: a review. Frontiers in Physiology 2010.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 15 years ago</li>
                                      <!----><!----><!---->
                                      <li class="badge low-risk hide-li ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!----><!----><!---->
                                      <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven12">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2010.00134"><span> Ammonia production, excretion, toxicity, and defense in fish: a review</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Ip Yuen
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Yuen Ip</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2010</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven13">
                                      <ul class="icon-list">
                                          <li>
                                              Raj L, Ide T, Gurkar AU, Foley M, Schenone M, Li X, Tolliday NJ, Golub TR, Carr SA, Shamji AF, Stern AM, Mandinova A, Schreiber SL, Lee SW. Selective killing of cancer cells by a small molecule targeting the stress
                                              response to ROS. NATURE: JUL 2011.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 14 years ago</li>
                                      <!----><!----><!---->
                                      <li class="badge low-risk hide-li ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!----><!----><!---->
                                      <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven13">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1038/nature10167">
                                                      <span> Selective killing of cancer cells by a small molecule targeting the stress response to ROS</span>
                                                  </a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Raj Lakshmi et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Lakshmi Raj</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Takao Ide</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Aditi U. Gurkar</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Michael Foley</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Monica Schenone</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Xiaoyu Li</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Nicola J. Tolliday</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Todd R. Golub</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Steven A. Carr</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Alykhan F. Shamji</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Andrew M. Stern</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Anna Mandinova</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Stuart L. Schreiber</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Sam W. Lee</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2011</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven14">
                                      <ul class="icon-list">
                                          <li>Becchetti A, Munaron L, Arcangeli A. The role of ion channels and transporters in cell proliferation and cancer. Frontiers in physiology 2013; 4:312.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                      <!----><!----><!---->
                                      <li class="badge low-risk hide-li ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!----><!----><!---->
                                      <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven14">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2013.00312"><span> The role of ion channels and transporters in cell proliferation and cancer</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Becchetti Andrea et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Andrea Becchetti</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Luca Munaron</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Annarosa Arcangeli</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2013</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven15">
                                      <ul class="icon-list">
                                          <li>Heimo Mairbäurl. Red blood cells in sports: effects of exercise and training on oxygen supply by red blood cells. Frontiers in Physiology 2013.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                      <!----><!----><!---->
                                      <li class="badge low-risk hide-li ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!----><!----><!---->
                                      <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven15">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2013.00332">
                                                      <span> Red blood cells in sports: effects of exercise and training on oxygen supply by red blood cells</span>
                                                  </a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Mairbäurl Heimo
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Heimo Mairbäurl</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2013</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven16">
                                      <ul class="icon-list">
                                          <li>Djuna Z. de Back, Elena B. Kostova, Marian van Kraaij, Timo K. van den Berg and Robin van Bruggen. Of macrophages and red blood cells; a complex love story. Frontiers in Physiology 2014.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                      <!----><!----><!---->
                                      <li class="badge low-risk hide-li ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!----><!----><!---->
                                      <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven16">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2014.00009"><span> Of macrophages and red blood cells; a complex love story</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      de Back Djuna Z. et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Djuna Z. de Back</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Elena B. Kostova</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Marian van Kraaij</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Timo K. van den Berg</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Robin van Bruggen</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2014</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven17">
                                      <ul class="icon-list">
                                          <li>SeongHun Yoon, Mario Zuccarello and Robert M. Rapoport. pCO2 and pH regulation of cerebral blood flow. Frontiers in Physiology 2010.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 13 years ago</li>
                                      <!----><!----><!---->
                                      <li class="badge low-risk hide-li ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!----><!----><!---->
                                      <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven17">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b><a target="_blank" href="https://dx.doi.org/10.3389/fphys.2012.00365"><span> pCO2 and pH regulation of cerebral blood flow</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Yoon SeongHun et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>SeongHun Yoon</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Mario Zuccarello</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Robert M. Rapoport</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2012</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven18">
                                      <ul class="icon-list">
                                          <li>Del Rio A, Perez-Jimenez R, Liu R, Roca-Cusachs P, Fernandez JM, Sheetz MP. Stretching single talin rod molecules activates vinculin binding. Science 2009; 323:638-41.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 16 years ago</li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven18">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1126/science.1162912"><span> Stretching Single Talin Rod Molecules Activates Vinculin Binding</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Science</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      del Rio Armando et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Armando del Rio</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Raul Perez-Jimenez</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Ruchuan Liu</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Pere Roca-Cusachs</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Julio M. Fernandez</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Michael P. Sheetz</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2009</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven19">
                                      <ul class="icon-list">
                                          <li>Goodman MB, Ernstrom GG, Chelur DS, O'Hagan R, Yao CA, Chalfie M. MEC-2 regulates C. elegans DEG/ENaC channels needed for mechanosensation. Nature 2002; 415:1039-42.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 23 years ago</li>
                                      <!----><!----><!---->
                                      <li class="badge low-risk hide-li ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!----><!----><!---->
                                      <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven19">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1038/4151039a"><span> MEC-2 regulates C. elegans DEG/ENaC channels needed for mechanosensation</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Goodman Miriam B. et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Miriam B. Goodman</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Glen G. Ernstrom</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Dattananda S. Chelur</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Robert O'Hagan</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>C. Andrea Yao</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Martin Chalfie</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2002</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven20">
                                      <ul class="icon-list">
                                          <li>Wang W, Black SS, Edwards MD, Miller S, Morrison EL, Bartlett W, et al. The structure of an open form of an E. coli mechanosensitive channel at 3.45 Å resolution. Science 2008; 321:1179-83.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 17 years ago</li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven20">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1126/science.1159262">
                                                      <span> The Structure of an Open Form of an&lt;i&gt;E. coli&lt;/i&gt;Mechanosensitive Channel at 3.45 Å Resolution</span>
                                                  </a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Science</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Wang Wenjian et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Wenjian Wang</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Susan S. Black</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Michelle D. Edwards</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Samantha Miller</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Emma L. Morrison</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Wendy Bartlett</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Changjiang Dong</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>James H. Naismith</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Ian R. Booth</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2008</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven21">
                                      <ul class="icon-list">
                                          <li>Brohawn SG, del Mármol J, MacKinnon R. Crystal structure of the human K2P TRAAK, a lipid-and mechano-sensitive K+ ion channel. Science 2012; 335:436-41.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 13 years ago</li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven21">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1126/science.1213808">
                                                      <span> Crystal Structure of the Human K2P TRAAK, a Lipid- and Mechano-Sensitive K &lt;sup&gt;+&lt;/sup&gt; Ion Channel</span>
                                                  </a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Science</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Brohawn Stephen G. et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Stephen G. Brohawn</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Josefina del Mármol</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Roderick MacKinnon</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2012</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven22">
                                      <ul class="icon-list">
                                          <li>Wemmie JA, Taugher RJ, Kreple CJ. Acid-sensing ion channels in pain and disease. Nature Reviews Neuroscience 2013; 14:461-71.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven22">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b><a target="_blank" href="https://dx.doi.org/10.1038/nrn3529"><span> Acid-sensing ion channels in pain and disease</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Nature Reviews Neuroscience</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Wemmie John A. et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>John A. Wemmie</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Rebecca J. Taugher</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Collin J. Kreple</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2013</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven23">
                                      <ul class="icon-list">
                                          <li>Tsantoulas C, McMahon SB. Opening paths to novel analgesics: the role of potassium channels in chronic pain. Trends in neurosciences 2014; 37:146-58.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven23">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1016/j.tins.2013.12.002">
                                                      <span> Opening paths to novel analgesics: the role of potassium channels in chronic pain</span>
                                                  </a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Trends in Neurosciences</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Tsantoulas Christoforos et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Christoforos Tsantoulas</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Stephen B. McMahon</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2014</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven24">
                                      <ul class="icon-list">
                                          <li>Delmas P, Coste B. Mechano-gated ion channels in sensory systems. Cell 2013; 155:278-84.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven24">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b><a target="_blank" href="https://dx.doi.org/10.1016/j.cell.2013.09.026"><span> Mechano-Gated Ion Channels in Sensory Systems</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Cell</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Delmas Patrick et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Patrick Delmas</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Bertrand Coste</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2013</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven25">
                                      <ul class="icon-list">
                                          <li>Moreau A, Gosselin-Badaroudine P, Chahine M. Biophysics, pathophysiology, and pharmacology of ion channel gating pores. Frontiers in pharmacology 2014; 5:53.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven25">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphar.2014.00053"><span> Biophysics, pathophysiology, and pharmacology of ion channel gating pores</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Pharmacology</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Moreau Adrien et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Adrien Moreau</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Pascal Gosselin-Badaroudine</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Mohamed Chahine</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2014</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven26">
                                      <ul class="icon-list">
                                          <li>Brohawn SG, Campbell EB, MacKinnon R. Physical mechanism for gating and mechanosensitivity of the human TRAAK K+ channel. Nature 2014; 516:126.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                      <!----><!----><!---->
                                      <li class="badge low-risk hide-li ng-star-inserted">Publishing journal used too many times</li>
                                      <!----><!----><!----><!---->
                                      <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven26">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1038/nature14013"><span> Physical mechanism for gating and mechanosensitivity of the human TRAAK K+ channel</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Brohawn Stephen G. et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Stephen G. Brohawn</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Ernest B. Campbell</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Roderick MacKinnon</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2014</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven27">
                                      <ul class="icon-list">
                                          <li>Peyronnet R, Tran D, Girault T, Frachisse J-M. Mechanosensitive channels: feeling tension in a world under pressure. Frontiers in plant science 2014; 5:558.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven27">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fpls.2014.00558"><span> Mechanosensitive channels: feeling tension in a world under pressure</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Plant Science</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Peyronnet RÃ©mi et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>RÃ©mi Peyronnet</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Daniel Tran</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Tiffanie Girault</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Jean-Marie Frachisse</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2014</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven28">
                                      <ul class="icon-list">
                                          <li>
                                              Schmidt D, del Mármol J, MacKinnon R. Mechanistic basis for low threshold mechanosensitivity in voltage-dependent K+ channels. Proceedings of the National Academy of Sciences 2012; 109:10352-7.
                                          </li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 13 years ago</li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven28">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1073/pnas.1204700109">
                                                      <span> Mechanistic basis for low threshold mechanosensitivity in voltage-dependent K &lt;sup&gt;+&lt;/sup&gt; channels</span>
                                                  </a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Proceedings of the National Academy of Sciences</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Schmidt Daniel et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Daniel Schmidt</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Josefina del Mármol</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Roderick MacKinnon</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2012</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="card ng-star-inserted">
                              <div class="card-header">
                                  <a class="card-link" data-toggle="collapse" href="#collapseSeven29">
                                      <ul class="icon-list">
                                          <li>Sukharev S, Sachs F. Molecular force transduction by ion channels–diversity and unifying principles. J Cell Sci 2012; 125:3075-83.</li>
                                      </ul>
                                  </a>
                              </div>
                              <div class="checklist-tags">
                                  <ul class="limitText">
                                      <!---->
                                      <li class="badge medium-risk ng-star-inserted">Published 13 years ago</li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                  </ul>
                              </div>
                              <div class="collapse" data-parent="#accordion" id="collapseSeven29">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para pc-title ng-star-inserted">
                                                  <b>Title:</b>
                                                  <a target="_blank" href="https://dx.doi.org/10.1242/jcs.092353"><span> Molecular force transduction by ion channels – diversity and unifying principles</span></a>
                                              </p>
                                              <!---->
                                          </div>
                                          <!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para"><b>Journal:</b><span> Journal of Cell Science</span></p>
                                          </div>
                                          <!----><!---->
                                          <div class="col-sm-12 ng-star-inserted">
                                              <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                      Sukharev Sergei et al.
                                                      <div class="popover-content">
                                                          <!---->
                                                          <ul class="ng-star-inserted">
                                                              <li>Sergei Sukharev</li>
                                                          </ul>
                                                          <ul class="ng-star-inserted">
                                                              <li>Frederick Sachs</li>
                                                          </ul>
                                                      </div>
                                                  </span>
                                              </p>
                                          </div>
                                          <!---->
                                          <div class="col-12">
                                              <!---->
                                              <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2012</span></p>
                                              <!---->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      
                   </div>
               </div>

               <!-- Unverified -->
               <div class="tab-pane" id="Unverified">
                 <div class="panel-card">
                   <h3>Unverified: 1 citations out of 41 <span class="badge medium-risk">Medium Risk</span></h3>
                   <div class="warning mt-4 mb-4">
                       <div class="media">
                         <div class="media-left">
                           <img src="../../../../../assets/images/Icon_Info.svg" alt="info">
                         </div>
                         <div class="media-body">
                           <p>We could not verify these citations using standard citation databases such as Crossref. This can happen due to a variety of issues, such as incompleteness of the citation databases, non-standard nature of the citations (e.g., personal communications or Wikipedia links), and so on. Please double check the citations under this category to ensure you are citing appropriate references to avoid peer review critique.</p>
                         </div>
                       </div>
                   </div>

                   <div class="danger-outline mb-4 ">
                     Action Required: Review these citations to make sure they are accurate.
                   </div>

                   <div class="rf-accordion" id="accordion">
                          <!---->
                          <div
                            
                             class="card ng-star-inserted"
                          >
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseEleven0">
                                      <ul class="icon-list">
                                         <li>Doe, J. (February 2024). AI is changing the workplace faster than expected. The New York Times. https://www.nytimes.com/example-article</li>
                                      </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                      <!---->
                                      <li
                                        
                                         class="badge medium-risk ng-star-inserted"
                                         style="display: inline-block;"
                                      >
                                         Unverified
                                      </li>
                                      <!----><!----><!----><!----><!----><!----><!---->
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseEleven0">
                                <div class="card-body">
                                      <div class="row">
                                         <div class="col-12">
                                            <!----><!---->
                                            <p class="pc-para pc-title ng-star-inserted"><b>Title:</b><span style="cursor: unset;"> AI is changing the workplace faster than expected</span></p>
                                         </div>
                                         <!----><!----><!----><!---->
                                         <div class="col-sm-12 ng-star-inserted">
                                            <p class="pc-para">
                                                  <b>Author:</b>
                                                  <span class="popover-item">
                                                     Doe J
                                                     <div class="popover-content">
                                                        <!---->
                                                        <ul class="ng-star-inserted">
                                                              <li>J Doe</li>
                                                        </ul>
                                                     </div>
                                                  </span>
                                            </p>
                                         </div>
                                         <div class="col-12">
                                            <!----><!---->
                                            <p class="pc-para ng-star-inserted"><b>Published:</b><span> 2024</span></p>
                                         </div>
                                      </div>
                                </div>
                             </div>
                          </div>
                    </div>

                 </div>
               </div>

               <!-- JournalOveruse -->
               <div class="tab-pane" id="JournalOveruse">
                   <div class="panel-card">
                       <h3>Journal Bias: 31% of citations are from 2 Journals <span class="badge low-risk">Low Risk</span></h3>
                       <div class="warning mt-4 mb-4">
                           <div class="media">
                             <div class="media-left">
                               <img src="../../../../../assets/images/Icon_Info.svg" alt="info">
                             </div>
                             <div class="media-body">
                               <p>Journal bias implies citing too many papers from a particular journal. This could be considered unethical practice to favour a particular journal. The report below helps you identify which journals have been cited too many times.</p>
                             </div>
                           </div>
                       </div>

                       <div class="danger-outline mb-4 ">
                           Action Required: Review every citation and replace with credible alternatives from other peer-reviewed journals.
                       </div>

                       <div class="rf-accordion" id="accordion1">
                          <!---->
                          <div
                             
                              class="card journal-card ng-star-inserted"
                              data-gtm-vis-first-on-screen13498092_510="2591069"
                              data-gtm-vis-total-visible-time13498092_510="100"
                              data-gtm-vis-has-fired13498092_510="1"
                              data-gtm-vis-first-on-screen13498092_522="2591074"
                              data-gtm-vis-total-visible-time13498092_522="100"
                              data-gtm-vis-has-fired13498092_522="1"
                          >
                              <div class="card-header journal-header">
                                  <a class="card-link collapsed" data-toggle="collapse" href="#JournalOne0" aria-expanded="false">
                                      <h3>Nature</h3>
                                      <p>
                                          5
                                          <!---->
                                          <span
                                             
                                              style="color: #4d4d4d; padding-right: 6px;"
                                              class="ng-star-inserted"
                                              data-gtm-vis-first-on-screen13498092_510="2591070"
                                              data-gtm-vis-total-visible-time13498092_510="100"
                                              data-gtm-vis-has-fired13498092_510="1"
                                              data-gtm-vis-first-on-screen13498092_522="2591077"
                                              data-gtm-vis-total-visible-time13498092_522="100"
                                              data-gtm-vis-has-fired13498092_522="1"
                                          >
                                              Citations
                                          </span>
                                          <!---->
                                          <span>(12% of all citations)</span>
                                      </p>
                                      <span class="icon"><i class="fa fa-caret-up"></i></span>
                                  </a>
                              </div>
                              <div class="collapse" data-parent="#accordion1" id="JournalOne0" style="">
                                  <div class="card-body">
                                      <div class="rf-accordion" id="accordion">
                                          <!---->
                                          <div
                                             
                                              class="card ng-star-inserted"
                                              data-gtm-vis-first-on-screen13498092_510="2977359"
                                              data-gtm-vis-total-visible-time13498092_510="100"
                                              data-gtm-vis-has-fired13498092_510="1"
                                              data-gtm-vis-first-on-screen13498092_522="2977394"
                                              data-gtm-vis-total-visible-time13498092_522="100"
                                              data-gtm-vis-has-fired13498092_522="1"
                                          >
                                              <div class="card-header">
                                                  <a class="card-link" data-toggle="collapse" href="#collapseTen0">
                                                      <ul class="icon-list">
                                                          <li>Hodgkin AL, Huxley AF. Action potentials recorded from inside a nerve fibre. Nature 1939; 144:710-1.</li>
                                                      </ul>
                                                  </a>
                                              </div>
                                              <div class="checklist-tags">
                                                  <ul class="limitText">
                                                      <!---->
                                                      <li
                                                         
                                                          class="badge low-risk ng-star-inserted"
                                                          data-gtm-vis-first-on-screen13498092_510="2977393"
                                                          data-gtm-vis-total-visible-time13498092_510="100"
                                                          data-gtm-vis-has-fired13498092_510="1"
                                                          data-gtm-vis-first-on-screen13498092_522="2977395"
                                                          data-gtm-vis-total-visible-time13498092_522="100"
                                                          data-gtm-vis-has-fired13498092_522="1"
                                                      >
                                                          Publishing journal used too many times
                                                      </li>
                                                      <!---->
                                                      <li class="badge medium-risk hide-li ng-star-inserted">Published 86 years ago</li>
                                                      <!----><!----><!----><!----><!---->
                                                  </ul>
                                              </div>
                                              <div class="collapse" data-parent="#accordion" id="collapseTen0">
                                                  <div class="card-body">
                                                      <div class="row">
                                                          <div class="col-12">
                                                              <p class="pc-para pc-title">
                                                                  <b>Title:</b>
                                                                  <a target="_blank" href="https://dx.doi.org/10.1038/144710a0"><span> Action Potentials Recorded from Inside a Nerve Fibre</span></a>
                                                              </p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para">
                                                                  <b>Author:</b>
                                                                  <span class="popover-item">
                                                                      HODGKIN A. L. et al.
                                                                      <div class="popover-content">
                                                                          <!---->
                                                                          <ul class="ng-star-inserted">
                                                                              <li>A. L. HODGKIN</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>A. F. HUXLEY</li>
                                                                          </ul>
                                                                      </div>
                                                                  </span>
                                                              </p>
                                                          </div>
                                                          <div class="col-12">
                                                              <p class="pc-para"><b>Published:</b><span> 1939</span></p>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                          <div
                                             
                                              class="card ng-star-inserted"
                                              data-gtm-vis-first-on-screen13498092_510="2977408"
                                              data-gtm-vis-total-visible-time13498092_510="100"
                                              data-gtm-vis-has-fired13498092_510="1"
                                              data-gtm-vis-first-on-screen13498092_522="2977429"
                                              data-gtm-vis-total-visible-time13498092_522="100"
                                              data-gtm-vis-has-fired13498092_522="1"
                                          >
                                              <div class="card-header">
                                                  <a class="card-link" data-toggle="collapse" href="#collapseTen1">
                                                      <ul class="icon-list">
                                                          <li>
                                                              Raj L, Ide T, Gurkar AU, Foley M, Schenone M, Li X, Tolliday NJ, Golub TR, Carr SA, Shamji AF, Stern AM, Mandinova A, Schreiber SL, Lee SW. Selective killing of cancer cells by a small molecule
                                                              targeting the stress response to ROS. NATURE: JUL 2011.
                                                          </li>
                                                      </ul>
                                                  </a>
                                              </div>
                                              <div class="checklist-tags">
                                                  <ul class="limitText">
                                                      <!---->
                                                      <li
                                                         
                                                          class="badge low-risk ng-star-inserted"
                                                          data-gtm-vis-first-on-screen13498092_510="2977428"
                                                          data-gtm-vis-total-visible-time13498092_510="100"
                                                          data-gtm-vis-has-fired13498092_510="1"
                                                          data-gtm-vis-first-on-screen13498092_522="2977430"
                                                          data-gtm-vis-total-visible-time13498092_522="100"
                                                          data-gtm-vis-has-fired13498092_522="1"
                                                      >
                                                          Publishing journal used too many times
                                                      </li>
                                                      <!---->
                                                      <li class="badge medium-risk hide-li ng-star-inserted">Published 14 years ago</li>
                                                      <!----><!----><!----><!----><!---->
                                                  </ul>
                                              </div>
                                              <div class="collapse" data-parent="#accordion" id="collapseTen1">
                                                  <div class="card-body">
                                                      <div class="row">
                                                          <div class="col-12">
                                                              <p class="pc-para pc-title">
                                                                  <b>Title:</b>
                                                                  <a target="_blank" href="https://dx.doi.org/10.1038/nature10167">
                                                                      <span> Selective killing of cancer cells by a small molecule targeting the stress response to ROS</span>
                                                                  </a>
                                                              </p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para">
                                                                  <b>Author:</b>
                                                                  <span class="popover-item">
                                                                      Raj Lakshmi et al.
                                                                      <div class="popover-content">
                                                                          <!---->
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Lakshmi Raj</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Takao Ide</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Aditi U. Gurkar</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Michael Foley</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Monica Schenone</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Xiaoyu Li</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Nicola J. Tolliday</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Todd R. Golub</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Steven A. Carr</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Alykhan F. Shamji</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Andrew M. Stern</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Anna Mandinova</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Stuart L. Schreiber</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Sam W. Lee</li>
                                                                          </ul>
                                                                      </div>
                                                                  </span>
                                                              </p>
                                                          </div>
                                                          <div class="col-12">
                                                              <p class="pc-para"><b>Published:</b><span> 2011</span></p>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                          <div
                                             
                                              class="card ng-star-inserted"
                                              data-gtm-vis-first-on-screen13498092_510="2977443"
                                              data-gtm-vis-total-visible-time13498092_510="100"
                                              data-gtm-vis-has-fired13498092_510="1"
                                              data-gtm-vis-first-on-screen13498092_522="2977460"
                                              data-gtm-vis-total-visible-time13498092_522="100"
                                              data-gtm-vis-has-fired13498092_522="1"
                                          >
                                              <div class="card-header">
                                                  <a class="card-link" data-toggle="collapse" href="#collapseTen2">
                                                      <ul class="icon-list">
                                                          <li>Zhao Q, Zhou H, Chi S, Wang Y, Wang J, Geng J, et al. Structure and mechanogating mechanism of the Piezo1 channel. Nature 2018; 554:487.</li>
                                                      </ul>
                                                  </a>
                                              </div>
                                              <div class="checklist-tags">
                                                  <ul class="limitText">
                                                      <!---->
                                                      <li
                                                         
                                                          class="badge low-risk ng-star-inserted"
                                                          data-gtm-vis-first-on-screen13498092_510="2977459"
                                                          data-gtm-vis-total-visible-time13498092_510="100"
                                                          data-gtm-vis-has-fired13498092_510="1"
                                                          data-gtm-vis-first-on-screen13498092_522="2977462"
                                                          data-gtm-vis-total-visible-time13498092_522="100"
                                                          data-gtm-vis-has-fired13498092_522="1"
                                                      >
                                                          Publishing journal used too many times
                                                      </li>
                                                      <!----><!----><!----><!----><!----><!---->
                                                  </ul>
                                              </div>
                                              <div class="collapse" data-parent="#accordion" id="collapseTen2">
                                                  <div class="card-body">
                                                      <div class="row">
                                                          <div class="col-12">
                                                              <p class="pc-para pc-title">
                                                                  <b>Title:</b>
                                                                  <a target="_blank" href="https://dx.doi.org/10.1038/nature25743"><span> Structure and mechanogating mechanism of the Piezo1 channel</span></a>
                                                              </p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para">
                                                                  <b>Author:</b>
                                                                  <span class="popover-item">
                                                                      Zhao Qiancheng et al.
                                                                      <div class="popover-content">
                                                                          <!---->
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Qiancheng Zhao</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Heng Zhou</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Shaopeng Chi</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Yanfeng Wang</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Jianhua Wang</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Jie Geng</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Kun Wu</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Wenhao Liu</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Tingxin Zhang</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Meng-Qiu Dong</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Jiawei Wang</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Xueming Li</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Bailong Xiao</li>
                                                                          </ul>
                                                                      </div>
                                                                  </span>
                                                              </p>
                                                          </div>
                                                          <div class="col-12">
                                                              <p class="pc-para"><b>Published:</b><span> 2018</span></p>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="card ng-star-inserted" data-gtm-vis-first-on-screen13498092_510="2977476" data-gtm-vis-total-visible-time13498092_510="100" data-gtm-vis-has-fired13498092_510="1">
                                              <div class="card-header">
                                                  <a class="card-link" data-toggle="collapse" href="#collapseTen3">
                                                      <ul class="icon-list">
                                                          <li>Goodman MB, Ernstrom GG, Chelur DS, O'Hagan R, Yao CA, Chalfie M. MEC-2 regulates C. elegans DEG/ENaC channels needed for mechanosensation. Nature 2002; 415:1039-42.</li>
                                                      </ul>
                                                  </a>
                                              </div>
                                              <div class="checklist-tags">
                                                  <ul class="limitText">
                                                      <!---->
                                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                                      <!---->
                                                      <li class="badge medium-risk hide-li ng-star-inserted">Published 23 years ago</li>
                                                      <!----><!----><!----><!----><!---->
                                                  </ul>
                                              </div>
                                              <div class="collapse" data-parent="#accordion" id="collapseTen3">
                                                  <div class="card-body">
                                                      <div class="row">
                                                          <div class="col-12">
                                                              <p class="pc-para pc-title">
                                                                  <b>Title:</b>
                                                                  <a target="_blank" href="https://dx.doi.org/10.1038/4151039a"><span> MEC-2 regulates C. elegans DEG/ENaC channels needed for mechanosensation</span></a>
                                                              </p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para">
                                                                  <b>Author:</b>
                                                                  <span class="popover-item">
                                                                      Goodman Miriam B. et al.
                                                                      <div class="popover-content">
                                                                          <!---->
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Miriam B. Goodman</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Glen G. Ernstrom</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Dattananda S. Chelur</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Robert O'Hagan</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>C. Andrea Yao</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Martin Chalfie</li>
                                                                          </ul>
                                                                      </div>
                                                                  </span>
                                                              </p>
                                                          </div>
                                                          <div class="col-12">
                                                              <p class="pc-para"><b>Published:</b><span> 2002</span></p>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="card ng-star-inserted">
                                              <div class="card-header">
                                                  <a class="card-link" data-toggle="collapse" href="#collapseTen4">
                                                      <ul class="icon-list">
                                                          <li>Brohawn SG, Campbell EB, MacKinnon R. Physical mechanism for gating and mechanosensitivity of the human TRAAK K+ channel. Nature 2014; 516:126.</li>
                                                      </ul>
                                                  </a>
                                              </div>
                                              <div class="checklist-tags">
                                                  <ul class="limitText">
                                                      <!---->
                                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                                      <!---->
                                                      <li class="badge medium-risk hide-li ng-star-inserted">Published 11 years ago</li>
                                                      <!----><!----><!----><!----><!---->
                                                  </ul>
                                              </div>
                                              <div class="collapse" data-parent="#accordion" id="collapseTen4">
                                                  <div class="card-body">
                                                      <div class="row">
                                                          <div class="col-12">
                                                              <p class="pc-para pc-title">
                                                                  <b>Title:</b>
                                                                  <a target="_blank" href="https://dx.doi.org/10.1038/nature14013">
                                                                      <span> Physical mechanism for gating and mechanosensitivity of the human TRAAK K+ channel</span>
                                                                  </a>
                                                              </p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para">
                                                                  <b>Author:</b>
                                                                  <span class="popover-item">
                                                                      Brohawn Stephen G. et al.
                                                                      <div class="popover-content">
                                                                          <!---->
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Stephen G. Brohawn</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Ernest B. Campbell</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Roderick MacKinnon</li>
                                                                          </ul>
                                                                      </div>
                                                                  </span>
                                                              </p>
                                                          </div>
                                                          <div class="col-12">
                                                              <p class="pc-para"><b>Published:</b><span> 2014</span></p>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div
                             
                              class="card journal-card ng-star-inserted"
                              data-gtm-vis-first-on-screen13498092_510="2591071"
                              data-gtm-vis-total-visible-time13498092_510="100"
                              data-gtm-vis-has-fired13498092_510="1"
                              data-gtm-vis-first-on-screen13498092_522="2591078"
                              data-gtm-vis-total-visible-time13498092_522="100"
                              data-gtm-vis-has-fired13498092_522="1"
                          >
                              <div class="card-header journal-header">
                                  <a class="card-link collapsed" data-toggle="collapse" href="#JournalOne1">
                                      <h3>Frontiers in Physiology</h3>
                                      <p>
                                          8
                                          <!---->
                                          <span
                                             
                                              style="color: #4d4d4d; padding-right: 6px;"
                                              class="ng-star-inserted"
                                              data-gtm-vis-first-on-screen13498092_510="2591072"
                                              data-gtm-vis-total-visible-time13498092_510="100"
                                              data-gtm-vis-has-fired13498092_510="1"
                                              data-gtm-vis-first-on-screen13498092_522="2591079"
                                              data-gtm-vis-total-visible-time13498092_522="100"
                                              data-gtm-vis-has-fired13498092_522="1"
                                          >
                                              Citations
                                          </span>
                                          <!---->
                                          <span>(19% of all citations)</span>
                                      </p>
                                      <span class="icon"><i class="fa fa-caret-up"></i></span>
                                  </a>
                              </div>
                              <div class="collapse" data-parent="#accordion1" id="JournalOne1">
                                  <div class="card-body">
                                      <div class="rf-accordion" id="accordion">
                                          <!---->
                                          <div class="card ng-star-inserted">
                                              <div class="card-header">
                                                  <a class="card-link" data-toggle="collapse" href="#collapseTen0">
                                                      <ul class="icon-list">
                                                          <li>Morris CE. Voltage-gated channel mechanosensitivity: fact or friction? Frontiers in physiology 2011; 2:25.</li>
                                                      </ul>
                                                  </a>
                                              </div>
                                              <div class="checklist-tags">
                                                  <ul class="limitText">
                                                      <!---->
                                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                                      <!---->
                                                      <li class="badge medium-risk hide-li ng-star-inserted">Published 14 years ago</li>
                                                      <!----><!----><!----><!----><!---->
                                                  </ul>
                                              </div>
                                              <div class="collapse" data-parent="#accordion" id="collapseTen0">
                                                  <div class="card-body">
                                                      <div class="row">
                                                          <div class="col-12">
                                                              <p class="pc-para pc-title">
                                                                  <b>Title:</b>
                                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2011.00025"><span> Voltage-Gated Channel Mechanosensitivity: Fact or Friction?</span></a>
                                                              </p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para">
                                                                  <b>Author:</b>
                                                                  <span class="popover-item">
                                                                      Morris Catherine E.
                                                                      <div class="popover-content">
                                                                          <!---->
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Catherine E. Morris</li>
                                                                          </ul>
                                                                      </div>
                                                                  </span>
                                                              </p>
                                                          </div>
                                                          <div class="col-12">
                                                              <p class="pc-para"><b>Published:</b><span> 2011</span></p>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="card ng-star-inserted">
                                              <div class="card-header">
                                                  <a class="card-link" data-toggle="collapse" href="#collapseTen1">
                                                      <ul class="icon-list">
                                                          <li>Yuen K. Ip, and Shit F. Chew. Ammonia production, excretion, toxicity, and defense in fish: a review. Frontiers in Physiology 2010.</li>
                                                      </ul>
                                                  </a>
                                              </div>
                                              <div class="checklist-tags">
                                                  <ul class="limitText">
                                                      <!---->
                                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                                      <!---->
                                                      <li class="badge medium-risk hide-li ng-star-inserted">Published 15 years ago</li>
                                                      <!----><!----><!----><!----><!---->
                                                  </ul>
                                              </div>
                                              <div class="collapse" data-parent="#accordion" id="collapseTen1">
                                                  <div class="card-body">
                                                      <div class="row">
                                                          <div class="col-12">
                                                              <p class="pc-para pc-title">
                                                                  <b>Title:</b>
                                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2010.00134">
                                                                      <span> Ammonia production, excretion, toxicity, and defense in fish: a review</span>
                                                                  </a>
                                                              </p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para">
                                                                  <b>Author:</b>
                                                                  <span class="popover-item">
                                                                      Ip Yuen
                                                                      <div class="popover-content">
                                                                          <!---->
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Yuen Ip</li>
                                                                          </ul>
                                                                      </div>
                                                                  </span>
                                                              </p>
                                                          </div>
                                                          <div class="col-12">
                                                              <p class="pc-para"><b>Published:</b><span> 2010</span></p>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="card ng-star-inserted">
                                              <div class="card-header">
                                                  <a class="card-link" data-toggle="collapse" href="#collapseTen2">
                                                      <ul class="icon-list">
                                                          <li>Becchetti A, Munaron L, Arcangeli A. The role of ion channels and transporters in cell proliferation and cancer. Frontiers in physiology 2013; 4:312.</li>
                                                      </ul>
                                                  </a>
                                              </div>
                                              <div class="checklist-tags">
                                                  <ul class="limitText">
                                                      <!---->
                                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                                      <!---->
                                                      <li class="badge medium-risk hide-li ng-star-inserted">Published 12 years ago</li>
                                                      <!----><!----><!----><!----><!---->
                                                  </ul>
                                              </div>
                                              <div class="collapse" data-parent="#accordion" id="collapseTen2">
                                                  <div class="card-body">
                                                      <div class="row">
                                                          <div class="col-12">
                                                              <p class="pc-para pc-title">
                                                                  <b>Title:</b>
                                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2013.00312">
                                                                      <span> The role of ion channels and transporters in cell proliferation and cancer</span>
                                                                  </a>
                                                              </p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para">
                                                                  <b>Author:</b>
                                                                  <span class="popover-item">
                                                                      Becchetti Andrea et al.
                                                                      <div class="popover-content">
                                                                          <!---->
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Andrea Becchetti</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Luca Munaron</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Annarosa Arcangeli</li>
                                                                          </ul>
                                                                      </div>
                                                                  </span>
                                                              </p>
                                                          </div>
                                                          <div class="col-12">
                                                              <p class="pc-para"><b>Published:</b><span> 2013</span></p>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="card ng-star-inserted">
                                              <div class="card-header">
                                                  <a class="card-link" data-toggle="collapse" href="#collapseTen3">
                                                      <ul class="icon-list">
                                                          <li>Jardín I, López JJ, Diez R, Sánchez-Collado J, Cantonero C, Albarrán L, et al. TRPs in pain sensation. Frontiers in physiology 2017; 8:392.</li>
                                                      </ul>
                                                  </a>
                                              </div>
                                              <div class="checklist-tags">
                                                  <ul class="limitText">
                                                      <!---->
                                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                                      <!----><!----><!----><!----><!----><!---->
                                                  </ul>
                                              </div>
                                              <div class="collapse" data-parent="#accordion" id="collapseTen3">
                                                  <div class="card-body">
                                                      <div class="row">
                                                          <div class="col-12">
                                                              <p class="pc-para pc-title">
                                                                  <b>Title:</b><a target="_blank" href="https://dx.doi.org/10.3389/fphys.2017.00392"><span> TRPs in Pain Sensation</span></a>
                                                              </p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para">
                                                                  <b>Author:</b>
                                                                  <span class="popover-item">
                                                                      Jardín Isaac et al.
                                                                      <div class="popover-content">
                                                                          <!---->
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Isaac Jardín</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>José J. López</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Raquel Diez</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>José Sánchez-Collado</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Carlos Cantonero</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Letizia Albarrán</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Geoffrey E. Woodard</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Pedro C. Redondo</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Ginés M. Salido</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Tarik Smani</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Juan A. Rosado</li>
                                                                          </ul>
                                                                      </div>
                                                                  </span>
                                                              </p>
                                                          </div>
                                                          <div class="col-12">
                                                              <p class="pc-para"><b>Published:</b><span> 2017</span></p>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="card ng-star-inserted">
                                              <div class="card-header">
                                                  <a class="card-link" data-toggle="collapse" href="#collapseTen4">
                                                      <ul class="icon-list">
                                                          <li>Heimo Mairbäurl. Red blood cells in sports: effects of exercise and training on oxygen supply by red blood cells. Frontiers in Physiology 2013.</li>
                                                      </ul>
                                                  </a>
                                              </div>
                                              <div class="checklist-tags">
                                                  <ul class="limitText">
                                                      <!---->
                                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                                      <!---->
                                                      <li class="badge medium-risk hide-li ng-star-inserted">Published 12 years ago</li>
                                                      <!----><!----><!----><!----><!---->
                                                  </ul>
                                              </div>
                                              <div class="collapse" data-parent="#accordion" id="collapseTen4">
                                                  <div class="card-body">
                                                      <div class="row">
                                                          <div class="col-12">
                                                              <p class="pc-para pc-title">
                                                                  <b>Title:</b>
                                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2013.00332">
                                                                      <span> Red blood cells in sports: effects of exercise and training on oxygen supply by red blood cells</span>
                                                                  </a>
                                                              </p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para">
                                                                  <b>Author:</b>
                                                                  <span class="popover-item">
                                                                      Mairbäurl Heimo
                                                                      <div class="popover-content">
                                                                          <!---->
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Heimo Mairbäurl</li>
                                                                          </ul>
                                                                      </div>
                                                                  </span>
                                                              </p>
                                                          </div>
                                                          <div class="col-12">
                                                              <p class="pc-para"><b>Published:</b><span> 2013</span></p>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="card ng-star-inserted">
                                              <div class="card-header">
                                                  <a class="card-link" data-toggle="collapse" href="#collapseTen5">
                                                      <ul class="icon-list">
                                                          <li>
                                                              Djuna Z. de Back, Elena B. Kostova, Marian van Kraaij, Timo K. van den Berg and Robin van Bruggen. Of macrophages and red blood cells; a complex love story. Frontiers in Physiology 2014.
                                                          </li>
                                                      </ul>
                                                  </a>
                                              </div>
                                              <div class="checklist-tags">
                                                  <ul class="limitText">
                                                      <!---->
                                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                                      <!---->
                                                      <li class="badge medium-risk hide-li ng-star-inserted">Published 11 years ago</li>
                                                      <!----><!----><!----><!----><!---->
                                                  </ul>
                                              </div>
                                              <div class="collapse" data-parent="#accordion" id="collapseTen5">
                                                  <div class="card-body">
                                                      <div class="row">
                                                          <div class="col-12">
                                                              <p class="pc-para pc-title">
                                                                  <b>Title:</b>
                                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2014.00009"><span> Of macrophages and red blood cells; a complex love story</span></a>
                                                              </p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para">
                                                                  <b>Author:</b>
                                                                  <span class="popover-item">
                                                                      de Back Djuna Z. et al.
                                                                      <div class="popover-content">
                                                                          <!---->
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Djuna Z. de Back</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Elena B. Kostova</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Marian van Kraaij</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Timo K. van den Berg</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Robin van Bruggen</li>
                                                                          </ul>
                                                                      </div>
                                                                  </span>
                                                              </p>
                                                          </div>
                                                          <div class="col-12">
                                                              <p class="pc-para"><b>Published:</b><span> 2014</span></p>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="card ng-star-inserted">
                                              <div class="card-header">
                                                  <a class="card-link" data-toggle="collapse" href="#collapseTen6">
                                                      <ul class="icon-list">
                                                          <li>SeongHun Yoon, Mario Zuccarello and Robert M. Rapoport. pCO2 and pH regulation of cerebral blood flow. Frontiers in Physiology 2010.</li>
                                                      </ul>
                                                  </a>
                                              </div>
                                              <div class="checklist-tags">
                                                  <ul class="limitText">
                                                      <!---->
                                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                                      <!---->
                                                      <li class="badge medium-risk hide-li ng-star-inserted">Published 13 years ago</li>
                                                      <!----><!----><!----><!----><!---->
                                                  </ul>
                                              </div>
                                              <div class="collapse" data-parent="#accordion" id="collapseTen6">
                                                  <div class="card-body">
                                                      <div class="row">
                                                          <div class="col-12">
                                                              <p class="pc-para pc-title">
                                                                  <b>Title:</b>
                                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2012.00365"><span> pCO2 and pH regulation of cerebral blood flow</span></a>
                                                              </p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para">
                                                                  <b>Author:</b>
                                                                  <span class="popover-item">
                                                                      Yoon SeongHun et al.
                                                                      <div class="popover-content">
                                                                          <!---->
                                                                          <ul class="ng-star-inserted">
                                                                              <li>SeongHun Yoon</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Mario Zuccarello</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Robert M. Rapoport</li>
                                                                          </ul>
                                                                      </div>
                                                                  </span>
                                                              </p>
                                                          </div>
                                                          <div class="col-12">
                                                              <p class="pc-para"><b>Published:</b><span> 2012</span></p>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="card ng-star-inserted">
                                              <div class="card-header">
                                                  <a class="card-link" data-toggle="collapse" href="#collapseTen7">
                                                      <ul class="icon-list">
                                                          <li>
                                                              Sun, Q., Li, T., Li, Y., Wei, L., Zhang, M., and Deng, S. Bactericidal/Permeability-Increasing Protein Improves Cognitive Impairment in Diabetic Mice via Blockade of the LPS-LBP-TLR4 Signaling
                                                              Pathway. Front. Physiol. 2021 11:718.
                                                          </li>
                                                      </ul>
                                                  </a>
                                              </div>
                                              <div class="checklist-tags">
                                                  <ul class="limitText">
                                                      <!---->
                                                      <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                                      <!----><!---->
                                                      <li class="badge high-risk hide-li ng-star-inserted">Retracted after publication</li>
                                                      <!----><!----><!----><!---->
                                                  </ul>
                                              </div>
                                              <div class="collapse" data-parent="#accordion" id="collapseTen7">
                                                  <div class="card-body">
                                                      <div class="row">
                                                          <div class="col-12">
                                                              <p class="pc-para pc-title">
                                                                  <b>Title:</b>
                                                                  <a target="_blank" href="https://dx.doi.org/10.3389/fphys.2020.00718">
                                                                      <span> RETRACTED: Bactericidal/Permeability-Increasing Protein Improves Cognitive Impairment in Diabetic Mice via Blockade of the LPS-LBP-TLR4 Signaling Pathway</span>
                                                                  </a>
                                                              </p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                          </div>
                                                          <!---->
                                                          <div class="col-sm-12 ng-star-inserted">
                                                              <p class="pc-para">
                                                                  <b>Author:</b>
                                                                  <span class="popover-item">
                                                                      Sun Qin et al.
                                                                      <div class="popover-content">
                                                                          <!---->
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Qin Sun</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Tingxin Li</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Yamei Li</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Lingling Wei</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Min Zhang</li>
                                                                          </ul>
                                                                          <ul class="ng-star-inserted">
                                                                              <li>Shaoping Deng</li>
                                                                          </ul>
                                                                      </div>
                                                                  </span>
                                                              </p>
                                                          </div>
                                                          <div class="col-12">
                                                              <p class="pc-para"><b>Published:</b><span> 2021</span></p>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      
                   </div>
               </div>

               <!-- goodCitations -->
               <div class="tab-pane" id="goodCitations">
                 <div class="panel-card">
                   <h3>6 citations out of 41 are good to use</h3>
                   <p class="good-msg ng-star-inserted">These citations are good to use in your document.</p>

                   <div class="danger-outline mb-4 ">
                     Action Required: Review these citations and replace with credible alternatives from other peer-reviewed journals.
                   </div>

                   <div class="rf-accordion" id="accordion">
                    <!---->
                    <div
                       
                        class="card ng-star-inserted"
                        data-gtm-vis-first-on-screen13498092_510="2868800"
                        data-gtm-vis-total-visible-time13498092_510="100"
                        data-gtm-vis-has-fired13498092_510="1"
                        data-gtm-vis-first-on-screen13498092_522="2868814"
                        data-gtm-vis-total-visible-time13498092_522="100"
                        data-gtm-vis-has-fired13498092_522="1"
                    >
                        <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen0">
                                <ul class="icon-list">
                                    <li>
                                        Murthy SE, Loud MC, Daou I, Marshall KL, Schwaller F, Kühnemund J, et al. The mechanosensitive ion channel Piezo2 mediates sensitivity to mechanical pain in mice. Science translational medicine 2018; 10:eaat9897.
                                    </li>
                                </ul>
                            </a>
                        </div>
                        <div class="collapse" data-parent="#accordion" id="collapseSixteen0">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <p class="pc-para pc-title">
                                            <b>Title:</b>
                                            <a target="_blank" href="https://dx.doi.org/10.1126/scitranslmed.aat9897">
                                                <span> The mechanosensitive ion channel Piezo2 mediates sensitivity to mechanical pain in mice</span>
                                            </a>
                                        </p>
                                    </div>
                                    <!---->
                                    <div class="col-sm-12 ng-star-inserted">
                                        <p class="pc-para"><b>Journal:</b><span> Science Translational Medicine</span></p>
                                    </div>
                                    <!---->
                                    <div class="col-sm-12 ng-star-inserted">
                                        <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                                Murthy Swetha E. et al.
                                                <div class="popover-content">
                                                    <!---->
                                                    <ul class="ng-star-inserted">
                                                        <li>Swetha E. Murthy</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Meaghan C. Loud</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Ihab Daou</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Kara L. Marshall</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Frederick Schwaller</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Johannes Kühnemund</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Allain G. Francisco</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>William T. Keenan</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Adrienne E. Dubin</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Gary R. Lewin</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Ardem Patapoutian</li>
                                                    </ul>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                    <div class="col-12">
                                        <p class="pc-para"><b>Published:</b><span> 2018</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                       
                        class="card ng-star-inserted"
                        data-gtm-vis-first-on-screen13498092_510="2868805"
                        data-gtm-vis-total-visible-time13498092_510="100"
                        data-gtm-vis-has-fired13498092_510="1"
                        data-gtm-vis-first-on-screen13498092_522="2868817"
                        data-gtm-vis-total-visible-time13498092_522="100"
                        data-gtm-vis-has-fired13498092_522="1"
                    >
                        <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen1">
                                <ul class="icon-list">
                                    <li>
                                        Kintzer AF, Green EM, Dominik PK, Bridges M, Armache J-P, Deneka D, et al. Structural basis for activation of voltage sensor domains in an ion channel TPC1. Proceedings of the National Academy of Sciences 2018;
                                        115:E9095-E104.
                                    </li>
                                </ul>
                            </a>
                        </div>
                        <div class="collapse" data-parent="#accordion" id="collapseSixteen1">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <p class="pc-para pc-title">
                                            <b>Title:</b>
                                            <a target="_blank" href="https://dx.doi.org/10.1073/pnas.1805651115"><span> Structural basis for activation of voltage sensor domains in an ion channel TPC1</span></a>
                                        </p>
                                    </div>
                                    <!---->
                                    <div class="col-sm-12 ng-star-inserted">
                                        <p class="pc-para"><b>Journal:</b><span> Proceedings of the National Academy of Sciences</span></p>
                                    </div>
                                    <!---->
                                    <div class="col-sm-12 ng-star-inserted">
                                        <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                                Kintzer Alexander F. et al.
                                                <div class="popover-content">
                                                    <!---->
                                                    <ul class="ng-star-inserted">
                                                        <li>Alexander F. Kintzer</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Evan M. Green</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Pawel K. Dominik</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Michael Bridges</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Jean-Paul Armache</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Dawid Deneka</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Sangwoo S. Kim</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Wayne Hubbell</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Anthony A. Kossiakoff</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Yifan Cheng</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Robert M. Stroud</li>
                                                    </ul>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                    <div class="col-12">
                                        <p class="pc-para"><b>Published:</b><span> 2018</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                       
                        class="card ng-star-inserted"
                        data-gtm-vis-first-on-screen13498092_510="2868806"
                        data-gtm-vis-total-visible-time13498092_510="100"
                        data-gtm-vis-has-fired13498092_510="1"
                        data-gtm-vis-first-on-screen13498092_522="2868820"
                        data-gtm-vis-total-visible-time13498092_522="100"
                        data-gtm-vis-has-fired13498092_522="1"
                    >
                        <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen2">
                                <ul class="icon-list">
                                    <li>Arrigoni C, Rohaim A, Shaya D, Findeisen F, Stein RA, Nurva SR, et al. Unfolding of a temperature-sensitive domain controls voltage-gated channel activation. Cell 2016; 164:922-36.</li>
                                </ul>
                            </a>
                        </div>
                        <div class="collapse" data-parent="#accordion" id="collapseSixteen2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <p class="pc-para pc-title">
                                            <b>Title:</b>
                                            <a target="_blank" href="https://dx.doi.org/10.1016/j.cell.2016.02.001">
                                                <span> Unfolding of a Temperature-Sensitive Domain Controls Voltage-Gated Channel Activation</span>
                                            </a>
                                        </p>
                                    </div>
                                    <!---->
                                    <div class="col-sm-12 ng-star-inserted">
                                        <p class="pc-para"><b>Journal:</b><span> Cell</span></p>
                                    </div>
                                    <!---->
                                    <div class="col-sm-12 ng-star-inserted">
                                        <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                                Arrigoni Cristina et al.
                                                <div class="popover-content">
                                                    <!---->
                                                    <ul class="ng-star-inserted">
                                                        <li>Cristina Arrigoni</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Ahmed Rohaim</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>David Shaya</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Felix Findeisen</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Richard&nbsp;A. Stein</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Shailika&nbsp;Reddy Nurva</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Smriti Mishra</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Hassane&nbsp;S. Mchaourab</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Daniel&nbsp;L. Minor</li>
                                                    </ul>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                    <div class="col-12">
                                        <p class="pc-para"><b>Published:</b><span> 2016</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                       
                        class="card ng-star-inserted"
                        data-gtm-vis-first-on-screen13498092_510="2868808"
                        data-gtm-vis-total-visible-time13498092_510="100"
                        data-gtm-vis-has-fired13498092_510="1"
                        data-gtm-vis-first-on-screen13498092_522="2868824"
                        data-gtm-vis-total-visible-time13498092_522="100"
                        data-gtm-vis-has-fired13498092_522="1"
                    >
                        <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen3">
                                <ul class="icon-list">
                                    <li>Ridone P, Vassalli M, Martinac B. Piezo1 mechanosensitive channels: what are they and why are they important. Biophysical Reviews 2019; 11:795-805.</li>
                                </ul>
                            </a>
                        </div>
                        <div class="collapse" data-parent="#accordion" id="collapseSixteen3">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <p class="pc-para pc-title">
                                            <b>Title:</b>
                                            <a target="_blank" href="https://dx.doi.org/10.1007/s12551-019-00584-5"><span> Piezo1 mechanosensitive channels: what are they and why are they important</span></a>
                                        </p>
                                    </div>
                                    <!---->
                                    <div class="col-sm-12 ng-star-inserted">
                                        <p class="pc-para"><b>Journal:</b><span> Biophysical Reviews</span></p>
                                    </div>
                                    <!---->
                                    <div class="col-sm-12 ng-star-inserted">
                                        <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                                Ridone Pietro et al.
                                                <div class="popover-content">
                                                    <!---->
                                                    <ul class="ng-star-inserted">
                                                        <li>Pietro Ridone</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Massimo Vassalli</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Boris Martinac</li>
                                                    </ul>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                    <div class="col-12">
                                        <p class="pc-para"><b>Published:</b><span> 2019</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                       
                        class="card ng-star-inserted"
                        data-gtm-vis-first-on-screen13498092_510="2870451"
                        data-gtm-vis-total-visible-time13498092_510="100"
                        data-gtm-vis-has-fired13498092_510="1"
                        data-gtm-vis-first-on-screen13498092_522="2870454"
                        data-gtm-vis-total-visible-time13498092_522="100"
                        data-gtm-vis-has-fired13498092_522="1"
                    >
                        <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen4">
                                <ul class="icon-list">
                                    <li>
                                        Deng Z, Maksaev G, Schlegel AM, Zhang J, Rau M, Fitzpatrick JAJ, et al. Structural mechanism for gating of a eukaryotic mechanosensitive channel of small conductance. Nature Communications 2020; 11:3690.
                                    </li>
                                </ul>
                            </a>
                        </div>
                        <div class="collapse" data-parent="#accordion" id="collapseSixteen4">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <p class="pc-para pc-title">
                                            <b>Title:</b>
                                            <a target="_blank" href="https://dx.doi.org/10.1038/s41467-020-17538-1">
                                                <span> Structural mechanism for gating of a eukaryotic mechanosensitive channel of small conductance</span>
                                            </a>
                                        </p>
                                    </div>
                                    <!---->
                                    <div class="col-sm-12 ng-star-inserted">
                                        <p class="pc-para"><b>Journal:</b><span> Nature Communications</span></p>
                                    </div>
                                    <!---->
                                    <div class="col-sm-12 ng-star-inserted">
                                        <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                                Deng Zengqin et al.
                                                <div class="popover-content">
                                                    <!---->
                                                    <ul class="ng-star-inserted">
                                                        <li>Zengqin Deng</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Grigory Maksaev</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Angela M. Schlegel</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Jingying Zhang</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Michael Rau</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>James A. J. Fitzpatrick</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Elizabeth S. Haswell</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Peng Yuan</li>
                                                    </ul>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                    <div class="col-12">
                                        <p class="pc-para"><b>Published:</b><span> 2020</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                       
                        class="card ng-star-inserted"
                        data-gtm-vis-first-on-screen13498092_510="2870452"
                        data-gtm-vis-total-visible-time13498092_510="100"
                        data-gtm-vis-has-fired13498092_510="1"
                        data-gtm-vis-first-on-screen13498092_522="2870456"
                        data-gtm-vis-total-visible-time13498092_522="100"
                        data-gtm-vis-has-fired13498092_522="1"
                    >
                        <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen5">
                                <ul class="icon-list">
                                    <li>Zhang W, Cheng LE, Kittelmann M, Li J, Petkovic M, Cheng T, et al. Ankyrin repeats convey force to gate the NOMPC mechanotransduction channel. Cell 2015; 162:1391-403.</li>
                                </ul>
                            </a>
                        </div>
                        <div class="collapse" data-parent="#accordion" id="collapseSixteen5">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <p class="pc-para pc-title">
                                            <b>Title:</b>
                                            <a target="_blank" href="https://dx.doi.org/10.1016/j.cell.2015.08.024"><span> Ankyrin Repeats Convey Force to Gate the NOMPC Mechanotransduction Channel</span></a>
                                        </p>
                                    </div>
                                    <!---->
                                    <div class="col-sm-12 ng-star-inserted">
                                        <p class="pc-para"><b>Journal:</b><span> Cell</span></p>
                                    </div>
                                    <!---->
                                    <div class="col-sm-12 ng-star-inserted">
                                        <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                                Zhang Wei et al.
                                                <div class="popover-content">
                                                    <!---->
                                                    <ul class="ng-star-inserted">
                                                        <li>Wei Zhang</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Li&nbsp;E. Cheng</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Maike Kittelmann</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Jiefu Li</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Maja Petkovic</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Tong Cheng</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Peng Jin</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Zhenhao Guo</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Martin&nbsp;C. Göpfert</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Lily&nbsp;Yeh Jan</li>
                                                    </ul>
                                                    <ul class="ng-star-inserted">
                                                        <li>Yuh&nbsp;Nung Jan</li>
                                                    </ul>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                    <div class="col-12">
                                        <p class="pc-para"><b>Published:</b><span> 2015</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                 </div>
               </div>

           </div>
       </div>
   </div>
 </div>
</section>
